/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState, useCallback, Fragment} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation} from 'react-i18next'
import {negoSatuan, negoAll, getScheduleOrder} from '../../../api/modules/order'
import Pagination from '../component/Pagination'
import {useNavigate, useParams} from 'react-router-dom'
import {create, getFile, deleteFile} from '../../../api/modules/file'
import CustomUseEffect from './CustomUseEffect'
import AddRemoveJadwal from './AddRemoveJadwal'
import axios from 'axios'
import {getDetailTracking, getRoleFlagList} from '../../../api/modules/master-data/master_2'
import {getAccesses} from '../../../api/modules/order'
import swal from 'sweetalert'
import {useDispatch, useSelector} from 'react-redux'
import {setGetNotif} from '../../../_metronic/redux/content'
import i18next from 'i18next'
import InputGroup from 'react-bootstrap/InputGroup'
import {Spinner} from 'react-bootstrap'
import {format} from 'date-fns'
import {getSalesAreaLetter} from '../../../api/modules/getdatalist'
import {id} from 'date-fns/locale'
import {setItemNego} from '../../../_metronic/redux/content'
import RowFilterOrder from './RowFilterOrder'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {initialState, orderSelector, setOrderFilter} from '../../../redux/slices/orderSlices'
import {CardHeader} from './CardHeader'
import {ExportOrderButton} from './ExportOrderButton'
import {AddOrderButton} from './AddOrderButton'
import {RowHeadOrder} from './RowHeadOrder'
import {PopoverText} from '../../../components/Popover/Popover'
import {fetchOrders, headers} from '../../../services/fetcher'
import {objToParams} from '../../../utils/objToParams'
import {TableLoader} from '../../../components/TableLoader'
import {TableFailedFetchData} from '../../../components/TableFailedFetchData'
import {TableEmptyData} from '../../../components/TableEmptyData'
import {DocFlow} from '../../../components/DocFlow'
import {MultiSelect} from 'react-multi-select-component'
import {ChatButton} from './ChatButton'
import * as TableUI from '../../../components/Table/Table'
import {useRowTable} from '../../../hooks/useRowTable'
import {StyledCard} from '../../../components/StyledCard'
import {appSelector} from '../../../redux/slices/appSlices'
import {HakAkses} from '../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'
import {BadgeColorOrder} from './BadgeColorOrder'
import dateformat from 'src/utils/dateformat'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import {ActionIcon} from 'src/components'
import {ShowAttachmentButton} from './ShowAttachmentButton'
import {AttachmentModal} from './AttachmentModal'
import {ChatOrderModal} from 'src/components/ChatOrderModal/ChatOrderModal'
import {setIsFetchData} from 'src/redux/slices/filterSlices'
import {SkeletonModal} from 'src/components'
import {SkeletonTracking} from './SkeletonTracking'
import {SkeletonSchedule} from './SkeletonSchedule'
import moment from 'moment'
import { InputFile } from 'src/app/components/InputFile'

type Props = {
  className: string
}

const TableOrder: React.FC<Props> = ({className}) => {
  const {orderFilter} = useAppSelector(orderSelector)
  const {roleId} = useAppSelector(authSelector)
  const hakAkses = HakAkses()
  const dispatch = useAppDispatch()
  const params = useParams()
  const {RowLoader, RowErrorFetch, RowEmptyData} = useRowTable({
    colSpan: 10,
    onReloadTable: () => handleResetTable(),
  })
  const [tooltip, setTooltip] = useState('Open')

  const handleOpen = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
      setTooltip('Close')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
      setTooltip('Open')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }

  const navigate = useNavigate()

  const [show1, setShow1] = useState(false)
  const [show4, setShow4] = useState(false)

  const [showUpload, setShowUpload] = useState(false)
  const [showEdit, setShowEdit] = useState(false)

  const handleShow = (po: any, amandemenflag: boolean) => {
    sessionStorage.setItem('po', po)
    if (hakAkses?.read || roleUser == 'null') {
      if (amandemenflag) {
        sessionStorage.setItem('amandemen', 'true')
        navigate('/management/order/amandemen/' + po)
      } else {
        sessionStorage.removeItem('amandemen')
        navigate('/management/order/detail/' + po)
      }
    }
  }
  const handleClose1 = () => setShow1(false)

  const [showJadwal, setShowJadwal] = useState(false)
  const [allJadwal, setAllJadwal] = useState<any[]>([])
  const bulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ]

  const [isLoadingSchedule, setIsLoadingSchedule] = useState(false)

  const handleShow2 = (id: any, id2 = 0, amand = 'false') => {
    sessionStorage.setItem('id', id)
    if (amand == 'false') {
      setShowJadwal(true)
    } else {
      setIsLoadingSchedule(true)
      const getJadwal = async () => {
        // let res = await getScheduleOrder(id, 'false')
        let res2 = await getScheduleOrder(id2, 'true')
        let tempArray: any[] = []
        tempArray = res2.data.data.schedules
        setAllJadwal(tempArray)
        setShowJadwal(true)
        setIsLoadingSchedule(false)
      }
      getJadwal()
    }
  }

  const handleClose4 = () => setShow4(false)
  const handleShow4 = () => setShow4(true)

  const {t} = useTranslation()
  const dispath = useDispatch()
  const notif = useSelector((state: any) => state.notif.getNotif)
  const credential = localStorage.getItem('credential')
  const [btnLoading, setBtnLoading] = useState(false)
  const [loadingDownload, setLoadingDownload] = useState(false)

  const [order, setOrder] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [numberURL, setNumberURL] = useState([])
  const [allFile, setAllFiles] = useState<any[]>([])
  const [isFailed, setIsFailed] = useState(false)
  const [dateNow, setDateNow] = useState('')
  const [salesOrg, setSalesOrg] = useState<any>()

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }
    setFixedQuantum(temp)
  }

  //#region
  const [fullDetail, setFullDetail] = useState({
    produsen: '',
    enduser: '',
    enduser2: '',
    idSektor: '',
    sektor: '',
    incoterm1: '',
    incoterm11: '',
    incoterm2: '',
    incoterm22: '',
    country: '',
    country_desc: '',
    province: '',
    province1: '',
    city: '',
    city1: '',
    warehouse: '',
    ptype: '',
    pname: '',
    pspec: '',
    subprice: '',
    quantum: '',
    note: '',
    pay1: '',
    pay11: '',
    pay2: '',
    pay22: '',
  })
  const [files, setFiles] = useState({file: null})
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [idOrder, setIDOrder] = useState('')
  const [sektorID, setSektorID] = useState('')
  const [param, setParam] = useState('')
  const [downloadOnly, setDownloadOnly] = useState(false)
  const [subID, setSubID] = useState(0)
  const [is_amandemen, setis_amandement] = useState('false')
  const [fullRole, setFullRole] = useState<any[]>([])
  const [tempRole, setTempRole] = useState<any[]>([])
  const [regarding, setRegarding] = useState('')
  const [nonpenjualan, setNonPenjualan] = useState('')
  const [fileBox, setFileBox] = useState<any>({})

  const [test, setTest] = useState<any>({})
  const [test2, setTest2] = useState<any>({})
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [requestQuantum, setReqeustQuantum] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState<any>('')
  //#endregion

  const [roleUser, setRoleUser] = useState('')
  const [accesses, setAccesses] = useState<any>()
  const [filterAsc, setFilterAsc] = useState<any>('')
  const [filterCus, setFilterCus] = useState<any>('')

  const onFetchOrders = useCallback(() => {
    setLoading(true)
    setIsFailed(false)
    fetchOrders(orderFilter)
      .then((res) => {
        setOrder(res.data.data.data)
        setNumberURL(res.data.data.links)
      })
      .catch(() => setIsFailed(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [orderFilter])

  useEffect(() => {
    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    setDateNow(dd + '-' + mm + '-' + yyyy)

    const getSalesOrg = async () => {
      const res = await getSalesAreaLetter()
      setSalesOrg(res.data.data)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }

    getSalesOrg()
    getAccessMenu()
    role()
    getAllRoleList()
  }, [])

  const paginateNumber = async (url: string) => {
    if (!url) return

    setLoading(true)

    const credentials = localStorage.getItem('credential') as string
    const token = localStorage.getItem('token') as string
    const endpoint = `${url}&credentials=${credentials}&${objToParams(orderFilter)}`
    const res = await axios.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})

    setOrder(res.data.data.data)
    setLoading(false)
    setNumberURL(res.data.data.links)
  }

  const ambilAttachment = async () => {
    await getFile(param, idOrder, localStorage.getItem('credential')!).then((res) => {
      setAllFiles(res.data.data)
      setShowUpload(true)
    })
  }

  CustomUseEffect(() => {
    setShowEdit(true)
  }, [fullDetail])

  const clearInputUpload = () => {
    const input1 = document.getElementById('uploadketerangan') as HTMLInputElement
    input1.value = ''
    const input2 = document.getElementById('upload') as HTMLInputElement
    input2.value = ''
    const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement
    inputPrivate.checked = false
    // const input3 = document.getElementById("uploadnama") as HTMLInputElement
    // input3.value = ''
    // const input4 = document.getElementById("uploadjenis") as HTMLInputElement
    // input4.value = t('Select file type')
  }

  const removeFileState = () => {
    setFiles({file: null})
    setNamaFile('')
    setDescription('')
    setDataType('')
    setIsPrivate(false)
    setTempRole([])
  }

  //accsess delete fileBox
  const accsessDelete = useSelector(
    (state: any) => state.appPersistedReducer.selectedMenu.attachment_delete
  )

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment()
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
      }
    })
  }

  const handleUpload = async () => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    let temparray: any[] = []
    if (tempRole.length > 0) {
      tempRole.forEach((data: any) => {
        temparray.push(data.value)
      })
    }
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', idOrder)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('roles', JSON.stringify(temparray))
    formdata.append('credentials', localStorage.getItem('credential')!)

    await create(param, formdata)
      .then((res) => {
        if (!res.data.error) {
          swal({
            title: `${t('document uploaded successfully')}`,
            icon: 'success',
          })
          ambilAttachment()
          removeFileState()
          clearInputUpload()
          dispath(setGetNotif(!notif))
        } else {
          swal({
            title: t(res.data.message),
            icon: 'error',
          })
        }
      })
      .catch(function (error) {
        if (error) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const tampilUpload = async (id: any, paramm: any, id2 = 0, amand: any) => {
    try {
      if (amand == 'false') {
        setIDOrder(id)
        await getFile(paramm, id, localStorage.getItem('credential')!).then((res) => {
          setAllFiles(res.data.data)
          setShowUpload(true)
        })
      } else {
        const ambilJadwal = async () => {
          let res2 = await getFile('order-item', id2, localStorage.getItem('credential')!)
          let res = await getFile('amandemen', id, localStorage.getItem('credential')!)
          let tempArray: any[] = []
          tempArray = tempArray.concat(res2.data.data, res.data.data)
          setAllFiles(tempArray)
          setShowUpload(true)
        }
        ambilJadwal()
      }
    } catch (err) {}
  }

  //#endregion

  const [track, setTrack] = useState<any>([])
  const [isLoadingTracking, setIsLoadingTracking] = useState(true)

  const handleTracking = async (id: any) => {
    setIsLoadingTracking(true)
    const res = await getDetailTracking(id)
    setTrack(res.data.data.data[0]?.statuses)
    setIsLoadingTracking(false)
    handleShow4()
  }

  useEffect(() => {
    const getData = setTimeout(onFetchOrders, 1000)
    return () => clearTimeout(getData)
  }, [onFetchOrders])

  const [language, setLanguage] = useState<any>()

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const toNego = async (id: any, PO: any) => {
    dispath(setItemNego({id, type: 'single', url: '/management/order/all', id_PO: PO}))
    navigate('/negotiate')
  }

  const toNegoAll = async (ID: any, PO: any, item: any) => {
    // console.log(item,'item');
    let idxNego = null

    const handleNego = (items: any) => {
      let tmpNego = 0
      items.map((item: any, idx: any) => {
        if (item.status == 5 || item.status == 3) {
          idxNego = idx
          tmpNego += 1
        }
      })

      return tmpNego
    }

    if (handleNego(item.children) > 1) {
      dispath(setItemNego({id: PO, type: 'multiple', url: '/management/order/all', id_PO: PO}))
      navigate('/negotiate')
    } else {
      dispath(setItemNego({id: ID, type: 'parent', idx: idxNego, url: '/management/order/all', id_PO: PO}))
      navigate('/negotiate')
    }
  }

  const salesAdd = () => {
    sessionStorage.setItem('sales', 'ada')
    navigate('/management/order/create')
  }

  const handleDownload = async () => {
    setLoadingDownload(true)

    let data = {
      customer_name: orderFilter?.customer_name || undefined,
      customer_name_orderby: orderFilter?.customer_name_orderby || undefined,
      flag: orderFilter?.flag || undefined,
      from_date: orderFilter?.from_date || undefined,
      po_number: orderFilter?.po_number || undefined,
      po_number_orderby: orderFilter?.po_number_orderby || undefined,
      regarding: orderFilter?.regarding || undefined,
      sales_org_code: orderFilter?.sales_org_code || undefined,
      sector_id: orderFilter?.sector_id || undefined,
      status: orderFilter?.status || undefined,
      to_date: orderFilter?.to_date || undefined,
      total_request_price: orderFilter?.total_request_price || undefined,
      total_request_quantum: orderFilter?.total_request_quantum || undefined,
      credentials: localStorage.getItem('credential'),
    }
    try {
      const res = await axios({
        url: `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/order-submission/export`,
        method: 'GET',
        params: data,
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      })
      const href = URL.createObjectURL(res.data)

      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', `PI_Order-Submission_${dateNow}.xlsx`)
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      setLoadingDownload(false)
    } catch {
      swal({
        title: t('Export Failed'),
        icon: 'error',
      })
      setLoadingDownload(false)
    }
  }

  const handleTrack = (data: string) => {
    const track = data.split(' - ')

    if (track[0].match('Menunggu Persetujuan Level')) {
      const tmp = track[0].split(' ')
      if (track[0].match('(Kontrak)')) {
        return (
          t(
            track[0]
              .replace('Menunggu Persetujuan Level', t('Waiting for Appproval'))
              .replace(tmp[3], '')
              .replace('#ID', tmp[3])
              .replace('(Kontrak)', t('(Kontrak)'))
          ) + (track[1] ? ' - ' + track[1] : '')
        )
      }
      if (track[0].match('(Rollback SIP)')) {
        return t(
          track[0]
            .replace('Menunggu Persetujuan Level', t('Waiting for Appproval'))
            .replace('#ID', tmp[1])
        )
      } else {
        return (
          t(
            track[0]
              .replace('Menunggu Persetujuan Level', t('Waiting for Appproval'))
              .replace(tmp[3], '')
              .replace('#ID', tmp[3])
          ) + (track[1] ? ' - ' + track[1] : '')
        )
      }
    } else {
      return t(track[0]) + (track[1] ? ' - ' + track[1] : '')
    }
  }
  function formatDate(input: any) {
    if (language == 'en') {
      const ndate = format(new Date(input), 'PPp')
      return ndate
    } else {
      const ndate = format(new Date(input), 'PPp', {locale: id})
      return ndate
    }
  }

  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const onParamsTypeChange = useCallback(() => {
    let _orderFilter = orderFilter
    try{
      let persisted = JSON.parse(localStorage.getItem('redux-order-filter') as string)
      _orderFilter = {
        ...orderFilter,
        ...persisted
      }
    }catch(e){}

    switch (params.type) {
      case 'new-order':
        dispatch(setOrderFilter({..._orderFilter, status: '', flag: '1'}))
        break

      case 'outstanding':
        dispatch(setOrderFilter({..._orderFilter, status: '', flag: '2'}))
        break

      case 'amandement':
        dispatch(setOrderFilter({..._orderFilter, status: '91', flag: ''}))
        break

      case 'reject':
        dispatch(setOrderFilter({..._orderFilter, status: '90', flag: ''}))
        break

      case 'finish':
        dispatch(setOrderFilter({..._orderFilter, status: '5', flag: ''}))
        break

      default:
        dispatch(setOrderFilter({..._orderFilter, status: '', flag: ''}))
        break
    }
  }, [params.type])

  const handleResetTable = () => {
    onParamsTypeChange()
  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  useEffect(() => {
    onParamsTypeChange()
  }, [onParamsTypeChange])

  /** Reset table when component unmount */
  useEffect(() => {
    return () => {
      onParamsTypeChange()
    }
  }, [])

  const isPurchase = (item: any) => {
    return (item.regarding == 'PO001') || (item.regarding == 'PO002' && ['INF-201', 'INF-202'].includes(item.non_sales_regarding))
  }

  const nonPurchaseButPurchase = (regarding == 'PO002' && ['INF-201', 'INF-202'].includes(nonpenjualan))
  const showPurchaseForm = regarding == 'PO001' || nonPurchaseButPurchase
  const isRetail = (sector: any): boolean => (sector == 2 || sector == 4)

  return (
    <StyledCard>
      {roleUser === 'null' && (
        <>
          <CardHeader
            right={
              <>
              { hakAkses?.create &&
                <Link
                  to='/management/order/create'
                  className='btn btn-primary d-flex align-items-center'
                >
                  <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                  <span className='d-block fs-6'>{t('order-tambahOrder')}</span>
                </Link>
              }
              </>
            }
          />

          <TableUI.TableWrapper>
            <TableUI.Table>
              <TableUI.THead>
                <RowHeadOrder />
              </TableUI.THead>

              <TableUI.TBody>
                <RowFilterOrder />

                {loading ? (
                  <RowLoader />
                ) : isFailed ? (
                  <RowErrorFetch />
                ) : order.length === 0 ? (
                  <RowEmptyData />
                ) : (
                  order.map((item, _index) => (
                    <Fragment key={_index}>
                      <tr
                        className={
                          item.status == 2 || item.is_amandemen || item.status_text.match('Revisi')
                            ? 'bg-kuning'
                            : ''
                        }
                      >
                        <td>
                          <div
                            className='d-flex p-0 justify-content-center'
                            style={{marginTop: '1px', marginBottom: '1.5px'}}
                          >
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mx-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title='Detail'
                              onClick={() => {
                                if (item.children.filter((osd: any) => osd.amendment_status == '2').length > 0) {
                                  sessionStorage.setItem('po', item.id)
                                  sessionStorage.setItem('amandemen', 'true')
                                  navigate('/management/order/amandemen/' + item.id)
                                } else {
                                  handleShow(item['id'], false)
                                }
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/file-text-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>

                            <ShowAttachmentButton
                                item={item}
                                attachment_type='header'
                                isDownloadOnly={false}
                              />

                            <ChatButton id={item.id} flag='order_sub_header' />
                          </div>
                        </td>
                        <td>
                          <div className='d-flex justify-content-evenly' style={{margin: '-.5px'}}>
                            <button
                              className='iconArow d-flex justify-content-start align-items-center'
                              data-target={'target' + item['id']}
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t(tooltip)}
                              onClick={handleOpen}
                            />
                            <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={item.children.filter((osd: any) => osd.amendment_status == '2').length > 0 ? ('/management/order/amandemen/' + item.id) : ('/management/order/detail/' + item.id)}
                              >
                                10{item['po_number']}
                              </Link>
                          </div>
                        </td>
                        <td>{dateformat(item.created_at)}</td>
                        <td>
                          <PopoverText
                            content={
                              item['customer']?.title == null || item.customer?.title == ''
                                ? item['customer']?.name
                                : item['customer']?.title + ' ' + item['customer']?.name
                            }
                            index={_index}
                            className='desc-slicee'
                          />
                        </td>
                        <td>{item.produsens_name.join(', ')}</td>
                        <td>
                          {item['regarding'] == 'PO001' ? (
                            <span className='badge badge-light-success'>{t('penjualan')}</span>
                          ) : (
                            <span className='badge badge-light-primary'>{t('Non-penjualan')}</span>
                          )}
                        </td>
                        <td>{t(item.sector?.name)}</td>
                        <td>
                          {item.regarding == 'PO001' ? (
                            <>
                              {item.amendment_submission == false ? (
                                <>
                                  {i18next.language === 'en'
                                    ? item.total_fixed_quantum.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : item.total_fixed_quantum.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}{' '}
                                  {item.sector_id === 3 ? 'MT' : 'Ton'}
                                </>
                              ) : (
                                <>
                                  {i18next.language === 'en'
                                    ? item.total_quantum_amandemen.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : item.total_quantum_amandemen.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}{' '}
                                  {item.sector_id === 3 ? 'MT' : 'Ton'}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {item.non_sales_regarding == 'INF-201' ||
                              item.non_sales_regarding == 'INF-202' ? (
                                <>
                                  {i18next.language === 'en'
                                    ? item.total_fixed_quantum.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : item.total_fixed_quantum.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}{' '}
                                  {item.sector_id === 3 ? 'MT' : 'Ton'}
                                </>
                              ) : (
                                ''
                              )}
                            </>
                          )}
                        </td>
                        <td>
                          {item.regarding == 'PO001' ? (
                            <>
                              {item.amendment_submission == false ? (
                                <>
                                  {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                    (i18next.language === 'en'
                                      ? item.total_fixed_price_quantum?.toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : item.total_fixed_price_quantum?.toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }))}
                                </>
                              ) : (
                                <>
                                  {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                    (i18next.language === 'en'
                                      ? item.total_price_amandemen?.toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : item.total_price_amandemen?.toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }))}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {item.non_sales_regarding == 'INF-201' ||
                              item.non_sales_regarding == 'INF-202' ? (
                                <>
                                  {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                    (i18next.language === 'en'
                                      ? item.total_fixed_price_quantum?.toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : item.total_fixed_price_quantum?.toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }))}
                                </>
                              ) : (
                                ''
                              )}
                            </>
                          )}
                        </td>
                        <td>
                          <BadgeColorOrder
                            text={item.status_text}
                            status={item.status}
                            type='header'
                          />
                        </td>                        
                      </tr>

                      <tr className='fold' id={'target' + item['id']}>
                        <TableUI.TableDetail colSpan={10}>
                          <TableUI.TableWrapper style={{marginBottom: 0}}>
                            <TableUI.Table>
                              {item.regarding == 'PO001' ? (
                                <>
                                  <TableUI.THead>
                                    <tr style={{backgroundColor: '#274070'}}>
                                      <th>{t('order-aksi')}</th>
                                      <th>{t('sub-order-item')}</th>
                                      {item.customer?.customer_account_group != 'AR03' ? (
                                        <>
                                          <th>Sales Org</th>
                                          <th>{t('sub-order-incoterm')}</th>
                                          <th>{t('sub-order-wilayah')}</th>
                                          <th>{t('sub-order-jenis')}</th>
                                          <th>{t('Product Code')}</th>
                                          <th>{t('sub-order-produk')}</th>
                                          <th>{t('sub-order-spek')}</th>
                                          {
                                            !isRetail(item.sector_id) ?
                                            <>
                                            <th>{t('Kuantum Pengajuan')}</th>
                                            <th>{t('Harga Pengajuan')}</th>
                                            <th>{t('sub-order-kuantumD')}</th>
                                            <th>{t('sub-order-hargaD')}</th>
                                            </>
                                            : <>
                                              <th>{t('kontrak-kuantum')}</th>
                                              <th>{t('Harga')}</th>
                                            </>
                                          }
                                          
                                        </>
                                      ) : (
                                        <>
                                          <th>Sales Org</th>
                                          <th>{t('sub-order-incoterm')}</th>
                                          <th>{t('sub-order-wilayah')}</th>
                                          <th>{t('sub-order-jenis')}</th>
                                          <th>{t('Product Code')}</th>
                                          <th>{t('sub-order-produk')}</th>
                                          <th>{t('sub-order-spek')}</th>
                                          {
                                            !isRetail(item.sector_id) ?
                                            <>
                                            <th>{t('Kuantum Pengajuan')}</th>
                                            <th>{t('Harga Pengajuan')}</th>
                                            <th>{t('sub-order-kuantumD')}</th>
                                            <th>{t('sub-order-hargaD')}</th>
                                            </>
                                            : <>
                                              <th>{t('kontrak-kuantum')}</th>
                                              <th>{t('Harga')}</th>
                                            </>
                                          }
                                        </>
                                      )}

                                      {item.sector?.id == 1 || item.sector?.id == 3 ? (
                                        <></>
                                      ) : (
                                        <th>{t('sub-order-gudang')}</th>
                                      )}

                                      <th>{t('sub-order-jadwalP')}</th>
                                      <th>Status</th>
                                    </tr>
                                  </TableUI.THead>
                                  <TableUI.TBody>
                                    {item.children?.map((subItem: any, _index: any) => (
                                      <tr key={_index}>
                                        {subItem.is_amendment == false ? (
                                          <>
                                            <td>
                                              <div className='d-flex'>
                                                <button
                                                  onClick={() => {
                                                    setTest(subItem)
                                                    setSektorID(item.sector_id)
                                                    setis_amandement('false')
                                                    setShowEdit(true)
                                                    setRegarding(item.regarding)
                                                  }}
                                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                                  data-bs-toggle='tooltip'
                                                  data-bs-placement='top'
                                                  data-bs-trigger='hover'
                                                  title='Detail'
                                                >
                                                  <KTSVG
                                                    path='/media/icons/duotune/file-text-fill.svg'
                                                    className='svg-icon-3'
                                                  />
                                                </button>

                                                {item.regarding == 'PO002' ? (
                                                  <button
                                                    onClick={() => {
                                                      setis_amandement('false')
                                                      setDownloadOnly(true)
                                                      setParam('order-item')
                                                      tampilUpload(
                                                        subItem.id,
                                                        'order-item',
                                                        0,
                                                        'false'
                                                      )
                                                      setFileBox(subItem)
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('order-lampiran')}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/arrow-down-square-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>
                                                ) : (
                                                  // <button
                                                  //   onClick={() => {
                                                  //     setis_amandement('false')
                                                  //     setDownloadOnly(false)
                                                  //     setParam('order-item')
                                                  //     tampilUpload(
                                                  //       subItem.id,
                                                  //       'order-item',
                                                  //       0,
                                                  //       'false'
                                                  //     )
                                                  //     setFileBox(subItem)
                                                  //   }}
                                                  //   className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                  //   data-bs-toggle='tooltip'
                                                  //   data-bs-placement='top'
                                                  //   data-bs-trigger='hover'
                                                  //   title={t('order-lampiran')}
                                                  // >
                                                  //   <KTSVG
                                                  //     path='/media/icons/duotune/archive-fill.svg'
                                                  //     className='svg-icon-3'
                                                  //   />
                                                  // </button>
                                                  <ShowAttachmentButton
                                                    item={subItem}
                                                    attachment_type={
                                                      subItem.is_new_item
                                                        ? 'amandemen'
                                                        : 'order-item'
                                                    }
                                                    isDownloadOnly={false}
                                                  />
                                                )}

                                                <button
                                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                  data-bs-toggle='tooltip'
                                                  data-bs-placement='top'
                                                  data-bs-trigger='hover'
                                                  title={t('Tracking')}
                                                  onClick={() => handleTracking(subItem.id)}
                                                >
                                                  <KTSVG
                                                    path='/media/icons/duotune/tracking.svg'
                                                    className='svg-icon-3'
                                                  />
                                                </button>
                                                <DocFlow id={subItem.id} />
                                                <ChatButton id={subItem.id} />
                                              </div>
                                            </td>
                                            <td>{_index + 1}</td>
                                            <td>{subItem.produsen?.name}</td>
                                            {isRetail(subItem.sector_id) ? (
                                              <>
                                                {subItem.incoterm2 == null ? (
                                                  <td>
                                                    {subItem.incoterm1?.code}-{subItem.incoterm2_id}
                                                  </td>
                                                ) : (
                                                  <td>
                                                    {subItem.incoterm1?.code}-
                                                    {subItem.incoterm2?.code}
                                                  </td>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                {subItem.incoterm2 == null ? (
                                                  <td>
                                                    {subItem.incoterm1?.code}
                                                    {subItem.incoterm2_id == null ||
                                                    subItem.incoterm2_id == '0'
                                                      ? ''
                                                      : '-' + subItem.incoterm2_id}
                                                  </td>
                                                ) : (
                                                  <td>
                                                    {subItem.incoterm1?.code}-
                                                    {subItem.incoterm2?.code}
                                                  </td>
                                                )}
                                              </>
                                            )}
                                            <td>
                                              {subItem.province?.region_name}
                                              {subItem.city?.city_name
                                                ? ', ' + subItem.city?.city_name
                                                : ''}
                                            </td>
                                            <td>{subItem.product_type_desc}</td>
                                            <td>
                                              {parseInt(subItem.material_number) == 0
                                                ? ''
                                                : subItem.material_number.slice(-7)}
                                            </td>
                                            <td>{subItem.product_name}</td>
                                            <td>
                                              <PopoverText
                                                content={subItem.product_spec}
                                                index={_index}
                                                className='spec-slice'
                                              />
                                            </td>
                                            {
                                              !isRetail(item.sector_id) && <>
                                                <td>
                                                  {i18next.language === 'en'
                                                    ? subItem.request_quantum?.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : subItem.request_quantum?.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })}{' '}
                                                  {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                                </td>
                                                <td>
                                                  {subItem.is_formulated_price ? (
                                                    <>{t('Formulated Price')}</>
                                                  ) : (
                                                    <>
                                                      {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                                        (i18next.language === 'en'
                                                          ? subItem.request_price?.toLocaleString(
                                                              'en',
                                                              {maximumFractionDigits: 4}
                                                            )
                                                          : subItem.request_price?.toLocaleString(
                                                              'id',
                                                              {maximumFractionDigits: 4}
                                                            )) +
                                                        (item.sector_id != 3 ? '/Ton' : '/MT')}
                                                    </>
                                                  )}
                                                </td>
                                              </>
                                            }
                                            {item.customer?.customer_account_group != 'AR03' ? (
                                              <>
                                                <td>
                                                  {i18next.language === 'en'
                                                    ? subItem.fixed_quantum?.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : subItem.fixed_quantum?.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })}{' '}
                                                  {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                                </td>
                                                <td>
                                                  {subItem.is_formulated_price ? (
                                                    <>{t('Formulated Price')}</>
                                                  ) : (
                                                    <>
                                                      {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                                        (i18next.language === 'en'
                                                          ? subItem.fixed_price?.toLocaleString(
                                                              'en',
                                                              {maximumFractionDigits: 4}
                                                            )
                                                          : subItem.fixed_price?.toLocaleString(
                                                              'id',
                                                              {maximumFractionDigits: 4}
                                                            )) +
                                                        (item.sector_id != 3 ? '/Ton' : '/MT')}
                                                    </>
                                                  )}
                                                </td>
                                              </>
                                            ) : (
                                              <>
                                                <td>
                                                  {i18next.language === 'en'
                                                    ? subItem.fixed_quantum?.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : subItem.fixed_quantum?.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })}{' '}
                                                  {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                                </td>
                                                <td>
                                                  {subItem.is_formulated_price ? (
                                                    <>{t('Formulated Price')}</>
                                                  ) : (
                                                    <>
                                                      {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                                        (i18next.language === 'en'
                                                          ? subItem.fixed_price?.toLocaleString(
                                                              'en',
                                                              {maximumFractionDigits: 4}
                                                            )
                                                          : subItem.fixed_price?.toLocaleString(
                                                              'id',
                                                              {maximumFractionDigits: 4}
                                                            )) +
                                                        (item.sector_id != 3 ? '/Ton' : '/MT')}
                                                    </>
                                                  )}
                                                </td>
                                              </>
                                            )}
                                            {item.sector?.id == 1 || item.sector?.id == 3 ? (
                                              <></>
                                            ) : (
                                              <td>{subItem.plant + " - " + subItem.plant_desc}</td>
                                            )}
                                            <td>
                                              <button
                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                data-bs-toggle='tooltip'
                                                data-bs-placement='top'
                                                data-bs-trigger='hover'
                                                title={t('Jadwal')}
                                                onClick={() => {
                                                  setSektorID(subItem.sector_id)
                                                  setProvinceName(subItem.province?.region_name)
                                                  setCityName(subItem.city?.city_name)
                                                  setProductName(subItem.product_name)
                                                  formattingTon(subItem.fixed_quantum)
                                                  setReqeustQuantum(subItem.request_quantum)
                                                  setSubID(subItem.id)
                                                  sessionStorage.setItem('isCustomer', 'false')
                                                  setis_amandement(
                                                    subItem.is_new_item ? 'true' : 'false'
                                                  )
                                                  if (subItem.is_new_item)
                                                    handleShow2(0, subItem.id, 'true')
                                                  else handleShow2(subItem.id)
                                                }}
                                              >
                                                <KTSVG
                                                  path='/media/icons/duotune/calendar-check-fill.svg'
                                                  className='svg-icon-3'
                                                />
                                              </button>
                                            </td>
                                            <td className='text-center'>
                                              <BadgeColorOrder
                                                text={subItem.status_text}
                                                status={subItem.status}
                                                type='item'
                                              />
                                            </td>
                                          </>
                                        ) : (
                                          <>
                                            <td>
                                              <div className='d-flex'>
                                                <button
                                                  onClick={() => {
                                                    setis_amandement('true')
                                                    setTest(subItem.amendment_orders[0])
                                                    setTest2(subItem)
                                                    setSektorID(item.sector_id)
                                                    setShowEdit(true)
                                                    setRegarding(item.regarding)
                                                  }}
                                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                                  data-bs-toggle='tooltip'
                                                  data-bs-placement='top'
                                                  data-bs-trigger='hover'
                                                  title='Detail'
                                                >
                                                  <KTSVG
                                                    path='/media/icons/duotune/file-text-fill.svg'
                                                    className='svg-icon-3'
                                                  />
                                                </button>

                                                {item.regarding == 'PO002' ? (
                                                  <button
                                                    onClick={() => {
                                                      setis_amandement('true')
                                                      setDownloadOnly(true)
                                                      setParam('amandemen')
                                                      tampilUpload(
                                                        subItem.amendment_orders[0]?.id,
                                                        'amandemen',
                                                        subItem.id,
                                                        'true'
                                                      )
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('order-lampiran')}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/arrow-down-square-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>
                                                ) : (
                                                  // <button
                                                  //   onClick={() => {
                                                  //     setis_amandement('true')
                                                  //     setDownloadOnly(false)
                                                  //     setParam('amandemen')
                                                  //     tampilUpload(
                                                  //       subItem.amendment_orders[0]?.id,
                                                  //       'amandemen',
                                                  //       subItem.id,
                                                  //       'true'
                                                  //     )
                                                  //   }}
                                                  //   className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                  //   data-bs-toggle='tooltip'
                                                  //   data-bs-placement='top'
                                                  //   data-bs-trigger='hover'
                                                  //   title={t('order-lampiran')}
                                                  // >
                                                  //   <KTSVG
                                                  //     path='/media/icons/duotune/archive-fill.svg'
                                                  //     className='svg-icon-3'
                                                  //   />
                                                  // </button>
                                                  <ShowAttachmentButton
                                                    item={subItem}
                                                    attachment_type='amandemen'
                                                    isDownloadOnly={false}
                                                  />
                                                )}

                                                <button
                                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                  data-bs-toggle='tooltip'
                                                  data-bs-placement='top'
                                                  data-bs-trigger='hover'
                                                  title={t('Tracking')}
                                                  onClick={() =>
                                                    handleTracking(
                                                      subItem.amendment_orders[0]
                                                        ?.order_sub_detail_id
                                                    )
                                                  }
                                                >
                                                  <KTSVG
                                                    path='/media/icons/duotune/tracking.svg'
                                                    className='svg-icon-3'
                                                  />
                                                </button>

                                                <DocFlow id={subItem.id} />
                                                <ChatButton id={subItem.id} />
                                              </div>
                                            </td>
                                            <td>{_index + 1}</td>
                                            <td>{subItem.amendment_orders[0]?.produsen?.name}</td>
                                            {isRetail(subItem.amendment_orders[0]?.sector_id) ? (
                                              <>
                                                {subItem.amendment_orders[0]?.incoterm2 == null ? (
                                                  <td>
                                                    {subItem.amendment_orders[0]?.incoterm1?.code}-
                                                    {subItem.amendment_orders[0]?.incoterm2_id}
                                                  </td>
                                                ) : (
                                                  <td>
                                                    {subItem.amendment_orders[0]?.incoterm1?.code}-
                                                    {subItem.amendment_orders[0]?.incoterm2?.code}
                                                  </td>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                {subItem.amendment_orders[0]?.incoterm2 == null ? (
                                                  <td>
                                                    {subItem.amendment_orders[0]?.incoterm1?.code}
                                                    {subItem.amendment_orders[0]?.incoterm2_id ==
                                                      null ||
                                                    subItem.amendment_orders[0]?.incoterm2_id == '0'
                                                      ? ''
                                                      : '-' +
                                                        subItem.amendment_orders[0]?.incoterm2_id}
                                                  </td>
                                                ) : (
                                                  <td>
                                                    {subItem.amendment_orders[0]?.incoterm1?.code}-
                                                    {subItem.amendment_orders[0]?.incoterm2?.code}
                                                  </td>
                                                )}
                                              </>
                                            )}
                                            <td>
                                              {subItem.amendment_orders[0]?.province?.region_name}
                                              {subItem.amendment_orders[0]?.city?.city_name
                                                ? ', ' +
                                                  subItem.amendment_orders[0]?.city?.city_name
                                                : ''}
                                            </td>
                                            <td>
                                              {subItem.amendment_orders[0]?.product_type_desc}
                                            </td>
                                            <td>
                                              {parseInt(
                                                subItem.amendment_orders[0]?.material_number
                                              ) == 0
                                                ? ''
                                                : subItem.amendment_orders[0]?.material_number?.slice(
                                                    -7
                                                  )}
                                            </td>
                                            <td>{subItem.amendment_orders[0]?.product_name}</td>
                                            <td>
                                              <PopoverText
                                                content={subItem.amendment_orders[0]?.product_spec}
                                                index={_index}
                                                className='spec-slice'
                                              />
                                            </td>
                                            {item.customer?.customer_account_group != 'AR03' ? (
                                              <>
                                                <td>
                                                  {i18next.language === 'en'
                                                    ? subItem.amendment_orders[0]?.request_quantum?.toLocaleString(
                                                        'en',
                                                        {maximumFractionDigits: 4}
                                                      )
                                                    : subItem.amendment_orders[0]?.request_quantum?.toLocaleString(
                                                        'id',
                                                        {maximumFractionDigits: 4}
                                                      )}{' '}
                                                  {subItem.amendment_orders[0]?.sector_id === 3
                                                    ? 'MT'
                                                    : 'Ton'}
                                                </td>
                                                <td className='text-center'>
                                                  {subItem.amendment_orders[0]
                                                    ?.is_formulated_price ? (
                                                    <>{t('Formulated Price')}</>
                                                  ) : (
                                                    <>
                                                      {(subItem.amendment_orders[0]?.sector_id != 3
                                                        ? 'Rp'
                                                        : 'USD') +
                                                        i18next.language ===
                                                      'en'
                                                        ? subItem.amendment_orders[0]?.request_price.toLocaleString(
                                                            'en',
                                                            {maximumFractionDigits: 4}
                                                          )
                                                        : subItem.amendment_orders[0]?.request_price.toLocaleString(
                                                            'id',
                                                            {maximumFractionDigits: 4}
                                                          ) +
                                                          (subItem.amendment_orders[0]?.sector_id !=
                                                          3
                                                            ? '/Ton'
                                                            : '/MT')}
                                                    </>
                                                  )}
                                                </td>
                                              </>
                                            ) : (
                                              <>
                                                <td>
                                                  {i18next.language === 'en'
                                                    ? subItem.amendment_orders[0]?.request_quantum?.toLocaleString(
                                                        'en',
                                                        {maximumFractionDigits: 4}
                                                      )
                                                    : subItem.amendment_orders[0]?.request_quantum?.toLocaleString(
                                                        'id',
                                                        {maximumFractionDigits: 4}
                                                      )}{' '}
                                                  {subItem.amendment_orders[0]?.sector_id === 3
                                                    ? 'MT'
                                                    : 'Ton'}
                                                </td>
                                                <td>
                                                  {subItem.amendment_orders[0]
                                                    ?.is_formulated_price ? (
                                                    <>{t('Formulated Price')}</>
                                                  ) : (
                                                    <>
                                                      {(subItem.amendment_orders[0]?.sector_id != 3
                                                        ? 'Rp'
                                                        : 'USD') +
                                                        i18next.language ===
                                                      'en'
                                                        ? subItem.amendment_orders[0]?.request_price.toLocaleString(
                                                            'en',
                                                            {maximumFractionDigits: 4}
                                                          )
                                                        : subItem.amendment_orders[0]?.request_price.toLocaleString(
                                                            'id',
                                                            {maximumFractionDigits: 4}
                                                          ) +
                                                          (subItem.amendment_orders[0]?.sector_id !=
                                                          3
                                                            ? '/Ton'
                                                            : '/MT')}
                                                    </>
                                                  )}
                                                </td>
                                              </>
                                            )}
                                            {item.customer?.customer_account_group != 'AR03' ? (
                                              <>
                                                <td>
                                                  {i18next.language === 'en'
                                                    ? subItem.fixed_quantum?.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : subItem.fixed_quantum?.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })}{' '}
                                                  {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                                </td>
                                                <td>
                                                  {subItem.is_formulated_price ? (
                                                    <>{t('Formulated Price')}</>
                                                  ) : (
                                                    <>
                                                      {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                                        (i18next.language === 'en'
                                                          ? subItem.fixed_price?.toLocaleString(
                                                              'en',
                                                              {maximumFractionDigits: 4}
                                                            )
                                                          : subItem.fixed_price?.toLocaleString(
                                                              'id',
                                                              {maximumFractionDigits: 4}
                                                            )) +
                                                        (item.sector_id != 3 ? '/Ton' : '/MT')}
                                                    </>
                                                  )}
                                                </td>
                                              </>
                                            ) : (
                                              <>
                                                <td>
                                                  {i18next.language === 'en'
                                                    ? subItem.fixed_quantum?.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : subItem.fixed_quantum?.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })}{' '}
                                                  {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                                </td>
                                                <td>
                                                  {subItem.is_formulated_price ? (
                                                    <>{t('Formulated Price')}</>
                                                  ) : (
                                                    <>
                                                      {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                                        (i18next.language === 'en'
                                                          ? subItem.fixed_price?.toLocaleString(
                                                              'en',
                                                              {maximumFractionDigits: 4}
                                                            )
                                                          : subItem.fixed_price?.toLocaleString(
                                                              'id',
                                                              {maximumFractionDigits: 4}
                                                            )) +
                                                        (item.sector_id != 3 ? '/Ton' : '/MT')}
                                                    </>
                                                  )}
                                                </td>
                                              </>
                                            )}
                                            {item.sector?.id == 1 || item.sector?.id == 3 ? (
                                              <></>
                                            ) : (
                                              <td>{subItem.amendment_orders[0]?.plant_desc}</td>
                                            )}
                                            <td>
                                              <button
                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                data-bs-toggle='tooltip'
                                                data-bs-placement='top'
                                                data-bs-trigger='hover'
                                                title={t('Jadwal')}
                                                onClick={() => {
                                                  setSektorID(
                                                    subItem.amendment_orders[0]?.sector_id
                                                  )
                                                  setProvinceName(
                                                    subItem.amendment_orders[0]?.province
                                                      ?.region_name
                                                  )
                                                  setCityName(
                                                    subItem.amendment_orders[0]?.city?.city_name
                                                  )
                                                  setProductName(
                                                    subItem.amendment_orders[0]?.product_name
                                                  )
                                                  formattingTon(
                                                    subItem.amendment_orders[0]?.fixed_quantum
                                                  )
                                                  setReqeustQuantum(
                                                    subItem.amendment_orders[0]?.request_quantum
                                                  )
                                                  setSubID(subItem.amendment_orders[0]?.id)
                                                  sessionStorage.setItem('isCustomer', 'false')
                                                  setis_amandement('true')
                                                  handleShow2(
                                                    subItem.id,
                                                    subItem.amendment_orders[0]?.id,
                                                    'true'
                                                  )
                                                }}
                                              >
                                                <KTSVG
                                                  path='/media/icons/duotune/calendar-check-fill.svg'
                                                  className='svg-icon-3'
                                                />
                                              </button>
                                            </td>
                                            <td className='text-center'>
                                              <BadgeColorOrder
                                                text={subItem.amendment_orders[0]?.status_text}
                                                status={subItem.amendment_orders[0]?.status}
                                                type='item'
                                              />
                                            </td>
                                          </>
                                        )}
                                      </tr>
                                    ))}
                                  </TableUI.TBody>
                                </>
                              ) : (
                                <>
                                  {item.non_sales_regarding == 'INF-201' ||
                                  item.non_sales_regarding == 'INF-202' ? (
                                    <>
                                      <TableUI.THead>
                                        <tr style={{backgroundColor: '#274070'}}>
                                          <th>{t('order-aksi')}</th>
                                          <th>{t('sub-order-item')}</th>
                                          <th>Sales Org</th>
                                          <th>{t('sub-order-incoterm')}</th>
                                          {item.sector_id != 3 ? (
                                            <th>{t('sub-order-wilayah')}</th>
                                          ) : (
                                            ''
                                          )}
                                          <th>{t('sub-order-jenis')}</th>
                                          <th>{t('Product Code')}</th>
                                          <th>{t('sub-order-produk')}</th>
                                          <th>{t('kontrak-kuantum')}</th>
                                          <th>{t('Harga')}</th>
                                          <th>Status</th>
                                        </tr>
                                      </TableUI.THead>
                                      <TableUI.TBody>
                                        {item.children?.map((subItem: any, _index: any) => (
                                          <tr key={_index}>
                                            <td>
                                              <div className='d-flex justify-content-center'>
                                                <button
                                                  onClick={() => {
                                                    setis_amandement('false')
                                                    setTest(subItem)
                                                    setSektorID(item.sector_id)
                                                    setShowEdit(true)
                                                    setRegarding(item.regarding)
                                                    setNonPenjualan(item.non_sales_regarding)
                                                  }}
                                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                                  data-bs-toggle='tooltip'
                                                  data-bs-placement='top'
                                                  data-bs-trigger='hover'
                                                  title='Detail'
                                                >
                                                  <KTSVG
                                                    path='/media/icons/duotune/file-text-fill.svg'
                                                    className='svg-icon-3'
                                                  />
                                                </button>

                                                <ShowAttachmentButton
                                                  item={subItem}
                                                  attachment_type={
                                                    subItem.is_new_item
                                                      ? 'amandemen'
                                                      : 'order-item'
                                                  }
                                                  isDownloadOnly={false}
                                                />

                                                <button
                                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                  data-bs-toggle='tooltip'
                                                  data-bs-placement='top'
                                                  data-bs-trigger='hover'
                                                  title={t('Tracking')}
                                                  onClick={() => handleTracking(subItem.id)}
                                                >
                                                  <KTSVG
                                                    path='/media/icons/duotune/tracking.svg'
                                                    className='svg-icon-3'
                                                  />
                                                </button>

                                                <DocFlow id={subItem.id} />
                                                <ChatButton id={subItem.id} />
                                              </div>
                                            </td>
                                            <td>{_index + 1}</td>
                                            <td>{subItem.produsen?.name}</td>
                                            <td>{subItem.incoterm1?.code}</td>
                                            {item.sector_id != 3 ? (
                                              <td>
                                                {subItem.province?.region_name},{' '}
                                                {subItem.city?.city_name}
                                              </td>
                                            ) : (
                                              ''
                                            )}

                                            <td>{subItem.product_type_desc}</td>
                                            <td>
                                              {parseInt(subItem.material_number) == 0
                                                ? ''
                                                : subItem.material_number.slice(-7)}
                                            </td>
                                            <td>{subItem.product_name}</td>
                                            <td>
                                              {i18next.language === 'en'
                                                ? subItem.fixed_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem.fixed_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })}{' '}
                                              {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                            </td>
                                            <td>
                                              {(subItem?.sector_id != 3 ? 'Rp' : 'USD') +
                                                (i18next.language === 'en'
                                                  ? subItem?.fixed_price.toLocaleString('en', {
                                                      maximumFractionDigits: 4,
                                                    })
                                                  : subItem?.fixed_price.toLocaleString('id', {
                                                      maximumFractionDigits: 4,
                                                    })) +
                                                (subItem?.sector_id != 3 ? '/Ton' : '/MT')}
                                            </td>
                                            <td>
                                              <BadgeColorOrder
                                                text={subItem?.status_text}
                                                status={subItem?.status}
                                                type='item'
                                              />
                                            </td>
                                          </tr>
                                        ))}
                                      </TableUI.TBody>
                                    </>
                                  ) : (
                                    <>
                                      <TableUI.THead>
                                        <tr style={{backgroundColor: '#274070'}}>
                                          <th>{t('order-aksi')}</th>
                                          <th>{t('sub-order-item')}</th>
                                          <th>Sales Org</th>
                                          <th>{t('sub-order-jenis')}</th>
                                          <th>{t('Product Code')}</th>
                                          <th>{t('sub-order-produk')}</th>
                                          <th>Status</th>
                                        </tr>
                                      </TableUI.THead>
                                      <TableUI.TBody>
                                        {item.children?.map((subItem: any, _index: any) => (
                                          <tr key={_index}>
                                            <td>
                                              <div className='d-flex justify-content-center'>
                                                <button
                                                  onClick={() => {
                                                    setis_amandement('false')
                                                    setTest(subItem)
                                                    setSektorID(item.sector_id)
                                                    setShowEdit(true)
                                                    setRegarding(item.regarding)
                                                    setNonPenjualan(item.non_sales_regarding)
                                                  }}
                                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                                  data-bs-toggle='tooltip'
                                                  data-bs-placement='top'
                                                  data-bs-trigger='hover'
                                                  title='Detail'
                                                >
                                                  <KTSVG
                                                    path='/media/icons/duotune/file-text-fill.svg'
                                                    className='svg-icon-3'
                                                  />
                                                </button>

                                                {item.regarding == 'PO002' ? (
                                                  // <button
                                                  //   onClick={() => {
                                                  //     setis_amandement('false')
                                                  //     setDownloadOnly(true)
                                                  //     setParam('order-item')
                                                  //     tampilUpload(
                                                  //       subItem.id,
                                                  //       'order-item',
                                                  //       0,
                                                  //       'false'
                                                  //     )
                                                  //     setFileBox(subItem)
                                                  //   }}
                                                  //   className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                  //   data-bs-toggle='tooltip'
                                                  //   data-bs-placement='top'
                                                  //   data-bs-trigger='hover'
                                                  //   title={t('order-lampiran')}
                                                  // >
                                                  //   <KTSVG
                                                  //     path='/media/icons/duotune/archive-fill.svg'
                                                  //     className='svg-icon-3'
                                                  //   />
                                                  // </button>
                                                  <ShowAttachmentButton
                                                    item={subItem}
                                                    attachment_type={
                                                      subItem.is_new_item
                                                        ? 'amandemen'
                                                        : 'order-item'
                                                    }
                                                    isDownloadOnly={true}
                                                  />
                                                ) : (
                                                  // <button
                                                  //   onClick={() => {
                                                  //     setis_amandement('false')
                                                  //     setDownloadOnly(false)
                                                  //     setParam('order-item')
                                                  //     tampilUpload(
                                                  //       subItem.id,
                                                  //       'order-item',
                                                  //       0,
                                                  //       'false'
                                                  //     )
                                                  //     setFileBox(subItem)
                                                  //   }}
                                                  //   className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                  //   data-bs-toggle='tooltip'
                                                  //   data-bs-placement='top'
                                                  //   data-bs-trigger='hover'
                                                  //   title={t('order-lampiran')}
                                                  // >
                                                  //   <KTSVG
                                                  //     path='/media/icons/duotune/archive-fill.svg'
                                                  //     className='svg-icon-3'
                                                  //   />
                                                  // </button>
                                                  <ShowAttachmentButton
                                                    item={subItem}
                                                    attachment_type={
                                                      subItem.is_new_item
                                                        ? 'amandemen'
                                                        : 'order-item'
                                                    }
                                                    isDownloadOnly={false}
                                                  />
                                                )}

                                                <button
                                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                  data-bs-toggle='tooltip'
                                                  data-bs-placement='top'
                                                  data-bs-trigger='hover'
                                                  title={t('Tracking')}
                                                  onClick={() => handleTracking(subItem.id)}
                                                >
                                                  <KTSVG
                                                    path='/media/icons/duotune/tracking.svg'
                                                    className='svg-icon-3'
                                                  />
                                                </button>

                                                <DocFlow id={subItem.id} />
                                                <ChatButton id={subItem.id} />
                                              </div>
                                            </td>
                                            <td>{_index + 1}</td>
                                            <td>{subItem.produsen?.name}</td>
                                            <td>{subItem.product_type_desc}</td>
                                            <td>
                                              {parseInt(subItem.material_number) == 0
                                                ? ''
                                                : subItem.material_number.slice(-7)}
                                            </td>
                                            <td>{subItem.product_name}</td>
                                            <td>
                                              <BadgeColorOrder
                                                text={subItem?.status_text}
                                                status={subItem?.status}
                                                type='item'
                                              />
                                            </td>
                                          </tr>
                                        ))}
                                      </TableUI.TBody>
                                    </>
                                  )}
                                </>
                              )}
                            </TableUI.Table>
                          </TableUI.TableWrapper>
                        </TableUI.TableDetail>
                      </tr>
                    </Fragment>
                  ))
                )}
              </TableUI.TBody>
            </TableUI.Table>
          </TableUI.TableWrapper>
        </>
      )}

      {(roleUser == 'salesAnper' || roleUser == 'otorisator' || roleUser == 'finance') && (
        <>
          <>
            <CardHeader
              right={
                hakAkses?.export && (
                  <ExportOrderButton isLoading={loadingDownload} onClick={handleDownload} />
                )
              }
            />

            <TableUI.TableWrapper>
              <TableUI.Table>
                <TableUI.THead>
                  <tr>
                    <th>{t('order-aksi')}</th>
                    <th>                      
                      {t('order-no')}
                      {filterAsc == '' || filterAsc == 'desc' ? (
                        <button
                          className='bg-transparent border-0'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('Sort')}
                          onClick={() => setFilterAsc('asc')}
                        >
                          <KTSVG
                            path='/media/icons/duotune/sort-down-alt.svg'
                            className='svg-icon-3 ms-1'
                          />
                        </button>
                      ) : (
                        <button
                          className='bg-transparent border-0'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('Sort')}
                          onClick={() => setFilterAsc('desc')}
                        >
                          <KTSVG
                            path='/media/icons/duotune/sort-up-alt.svg'
                            className='svg-icon-3 ms-1'
                          />
                        </button>
                      )}
                    </th>
                    <th>{t('order-tanggal')}</th>
                    <th>
                      {t('order-pelanggan')}
                      {filterCus == '' || filterCus == 'desc' ? (
                        <button
                          className='bg-transparent border-0'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('Sort')}
                          onClick={() => setFilterCus('asc')}
                        >
                          <KTSVG
                            path='/media/icons/duotune/sort-down-alt.svg'
                            className='svg-icon-3 ms-1'
                          />
                        </button>
                      ) : (
                        <button
                          className='bg-transparent border-0'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('Sort')}
                          onClick={() => setFilterCus('desc')}
                        >
                          <KTSVG
                            path='/media/icons/duotune/sort-up-alt.svg'
                            className='svg-icon-3 ms-1'
                          />
                        </button>
                      )}
                    </th>
                    <th>Sales Org</th>
                    <th>{t('order-perihal')}</th>
                    <th>{t('Sektor')}</th>
                    <th>{t('Total Kuantum')}</th>
                    <th>{t('Total Price')}</th>
                    <th>Status</th>
                  </tr>
                </TableUI.THead>

                <TableUI.TBody>
                  <RowFilterOrder />

                  {loading ? (
                    <RowLoader />
                  ) : isFailed ? (
                    <RowErrorFetch />
                  ) : order.length === 0 ? (
                    <RowEmptyData />
                  ) : (
                    order.map((item, _index) => (
                      <Fragment key={_index}>
                        <tr>
                        <td>
                            <div className='d-flex p-0 justify-content-center'>
                              <Link to={`/management/order/detail/${item.id}`}>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  hidden={hakAkses?.read ? false : true}
                                  title='Detail'
                                  onClick={() => handleShow(item['id'], false)}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/file-text-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              </Link>

                              {/* <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('order-lampiran')}
                                onClick={() => {
                                  setis_amandement('false')
                                  setParam('header')
                                  setDownloadOnly(false)
                                  tampilUpload(item.id, 'header', 0, 'false')
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/archive-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button> */}
                              <ShowAttachmentButton
                                item={item}
                                attachment_type='header'
                                isDownloadOnly={false}
                              />
                              <ChatButton id={item.id} flag='order_sub_header' />
                            </div>
                          </td>
                          <td>
                            <div className='d-flex justify-content-evenly align-items-center'>
                              <button
                                className='iconArow d-flex justify-content-start align-items-center'
                                data-target={'target' + item['id']}
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t(tooltip)}
                                onClick={handleOpen}
                              ></button>
                              <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={'/management/order/detail/' + item.id}
                              >
                                10{item['po_number']}
                              </Link>
                            </div>
                          </td>
                          <td>{dateformat(item.created_at)}</td>
                          <td>
                            <PopoverText
                              content={
                                item['customer']?.title == null || item.customer?.title == ''
                                  ? item['customer']?.name
                                  : item['customer']?.title + ' ' + item['customer']?.name
                              }
                              index={_index}
                              className='desc-slicee'
                            />
                          </td>
                          <td>{item.produsens_name.join(', ')}</td>
                          <td>
                            {item['regarding'] == 'PO001' ? (
                              <span className='badge badge-light-success'>{t('penjualan')}</span>
                            ) : (
                              <span className='badge badge-light-primary'>
                                {t('Non-penjualan')}
                              </span>
                            )}
                          </td>
                          <td>{t(item.sector?.name)}</td>
                          <td>
                            {item.regarding == 'PO001' ? (
                              <>
                                {item.amendment_submission == false ? (
                                  <>
                                    {i18next.language === 'en'
                                      ? item.total_fixed_quantum.toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : item.total_fixed_quantum.toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })}{' '}
                                    {item.sector_id === 3 ? 'MT' : 'Ton'}
                                  </>
                                ) : (
                                  <>
                                    {i18next.language === 'en'
                                      ? item.total_quantum_amandemen.toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : item.total_quantum_amandemen.toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })}{' '}
                                    {item.sector_id === 3 ? 'MT' : 'Ton'}
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {item.non_sales_regarding == 'INF-201' ||
                                item.non_sales_regarding == 'INF-202' ? (
                                  <>
                                    {i18next.language === 'en'
                                      ? item.total_fixed_quantum.toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : item.total_fixed_quantum.toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })}{' '}
                                    {item.sector_id === 3 ? 'MT' : 'Ton'}
                                  </>
                                ) : (
                                  ''
                                )}
                              </>
                            )}
                          </td>
                          <td>
                            {item.regarding == 'PO001' ? (
                              <>
                                {item.amendment_submission == false ? (
                                  <>
                                    {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                      (i18next.language === 'en'
                                        ? item.total_fixed_price_quantum?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : item.total_fixed_price_quantum?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          }))}
                                  </>
                                ) : (
                                  <>
                                    {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                      (i18next.language === 'en'
                                        ? item.total_price_amandemen?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : item.total_price_amandemen?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          }))}
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {item.non_sales_regarding == 'INF-201' ||
                                item.non_sales_regarding == 'INF-202' ? (
                                  <>
                                    {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                      (i18next.language === 'en'
                                        ? item.total_fixed_price_quantum?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : item.total_fixed_price_quantum?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          }))}
                                  </>
                                ) : (
                                  ''
                                )}
                              </>
                            )}
                          </td>
                          <td>
                            <BadgeColorOrder
                              text={item?.status_text}
                              status={item?.status}
                              type='header'
                            />
                          </td>
                        </tr>

                        <tr className='fold' id={'target' + item['id']}>
                          <TableUI.TableDetail colSpan={10}>
                            <TableUI.TableWrapper style={{marginBottom: 0}}>
                              <TableUI.Table>
                                {isPurchase(item) ? (
                                  <>
                                    <TableUI.THead>
                                      <tr style={{backgroundColor: '#274070'}}>
                                        <th>{t('order-aksi')}</th>
                                        <th>{t('sub-order-item')}</th>
                                        {item.customer?.customer_account_group != 'AR03' ? (
                                          <>
                                            <th>Sales Org</th>
                                            <th>{t('sub-order-incoterm')}</th>
                                            <th>{t('sub-order-wilayah')}</th>
                                            <th>{t('sub-order-jenis')}</th>
                                            <th>{t('Product Code')}</th>
                                            <th>{t('sub-order-produk')}</th>
                                            <th>{t('sub-order-spek')}</th>
                                            <th>{t('kontrak-kuantum')}</th>
                                            <th>{t('Harga')}</th>
                                          </>
                                        ) : (
                                          <>
                                            <th>Sales Org</th>
                                            <th>{t('sub-order-incoterm')}</th>
                                            <th>{t('sub-order-wilayah')}</th>
                                            <th>{t('sub-order-jenis')}</th>
                                            <th>{t('Product Code')}</th>
                                            <th>{t('sub-order-produk')}</th>
                                            <th>{t('sub-order-spek')}</th>
                                            <th>{t('kontrak-kuantum')}</th>
                                            <th>{t('Harga')}</th>
                                          </>
                                        )}

                                        {item.sector?.id == 1 || item.sector?.id == 3 ? (
                                          <></>
                                        ) : (
                                          <th>{t('sub-order-gudang')}</th>
                                        )}
                                        <th>{t('sub-order-jadwalP')}</th>
                                        <th>Status</th>
                                      </tr>
                                    </TableUI.THead>
                                    <TableUI.TBody>
                                      {item['children']?.map((subItem: any, _index: any) => (
                                        <tr key={subItem?.id ?? _index}>
                                          {subItem?.is_amendment == false ? (
                                            <>
                                               <td>
                                                <div className='d-flex justify-content-center align-items-center'>
                                                  <button
                                                    onClick={() => {
                                                      setis_amandement('false')
                                                      setTest(subItem)
                                                      setSektorID(item.sector_id)
                                                      setShowEdit(true)
                                                      setRegarding(item.regarding)
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    hidden={hakAkses?.read ? false : true}
                                                    title='Detail'
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/file-text-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>

                                                  {/* <button
                                                    onClick={() => {
                                                      setis_amandement('false')
                                                      setDownloadOnly(false)
                                                      setParam('order-item')
                                                      tampilUpload(
                                                        subItem.id,
                                                        'order-item',
                                                        0,
                                                        'false'
                                                      )
                                                      setFileBox(subItem)
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('order-lampiran')}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/archive-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button> */}
                                                  <ShowAttachmentButton
                                                    item={subItem}
                                                    attachment_type={
                                                      subItem.is_new_item
                                                        ? 'amandemen'
                                                        : 'order-item'
                                                    }
                                                    isDownloadOnly={false}
                                                  />

                                                  <button
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('Tracking')}
                                                    hidden={roleUser == 'otorisator' ? true : false}
                                                    onClick={() => handleTracking(subItem.id)}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/tracking.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>
                                                  <DocFlow id={subItem.id} />
                                                  <ChatButton id={subItem.id} />
                                                </div>
                                              </td>
                                              <td>{_index + 1}</td>
                                              <td>{subItem.produsen?.name}</td>
                                              {isRetail(subItem.sector_id) ? (
                                                <>
                                                  {subItem.incoterm2 == null ? (
                                                    <td>
                                                      {subItem.incoterm1?.code}-
                                                      {subItem.incoterm2_id}
                                                    </td>
                                                  ) : (
                                                    <td>
                                                      {subItem.incoterm1?.code}-
                                                      {subItem.incoterm2?.code}
                                                    </td>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  {subItem.incoterm2 == null ? (
                                                    <td>
                                                      {subItem.incoterm1?.code}
                                                      {subItem.incoterm2_id == null ||
                                                      subItem.incoterm2_id == '0'
                                                        ? ''
                                                        : '-' + subItem.incoterm2_id}
                                                    </td>
                                                  ) : (
                                                    <td>
                                                      {subItem.incoterm1?.code}-
                                                      {subItem.incoterm2?.code}
                                                    </td>
                                                  )}
                                                </>
                                              )}

                                              <td>
                                                {subItem.province?.region_name}
                                                {subItem.city?.city_name
                                                  ? ', ' + subItem.city?.city_name
                                                  : ''}
                                              </td>

                                              <td>{subItem.product_type_desc}</td>
                                              <td>
                                                {parseInt(subItem.material_number) == 0
                                                  ? ''
                                                  : subItem.material_number.slice(-7)}
                                              </td>
                                              <td>{subItem.product_name}</td>
                                              <td>
                                                <PopoverText
                                                  content={subItem.product_spec}
                                                  index={_index}
                                                  className='spec-slice'
                                                />
                                              </td>
                                              {item.customer?.customer_account_group != 'AR03' ? (
                                                <>
                                                  <td>
                                                    {i18next.language === 'en'
                                                      ? subItem.fixed_quantum?.toLocaleString(
                                                          'en',
                                                          {maximumFractionDigits: 4}
                                                        )
                                                      : subItem.fixed_quantum?.toLocaleString(
                                                          'id',
                                                          {maximumFractionDigits: 4}
                                                        )}{' '}
                                                    {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                                  </td>
                                                  <td>
                                                    {subItem.is_formulated_price ? (
                                                      <>{t('Formulated Price')}</>
                                                    ) : (
                                                      <>
                                                        {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                                          (i18next.language === 'en'
                                                            ? subItem.fixed_price?.toLocaleString(
                                                                'en',
                                                                {maximumFractionDigits: 4}
                                                              )
                                                            : subItem.fixed_price?.toLocaleString(
                                                                'id',
                                                                {maximumFractionDigits: 4}
                                                              )) +
                                                          (item.sector_id != 3 ? '/Ton' : '/MT')}
                                                      </>
                                                    )}
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td>
                                                    {i18next.language === 'en'
                                                      ? subItem.fixed_quantum?.toLocaleString(
                                                          'en',
                                                          {maximumFractionDigits: 4}
                                                        )
                                                      : subItem.fixed_quantum?.toLocaleString(
                                                          'id',
                                                          {maximumFractionDigits: 4}
                                                        )}{' '}
                                                    {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                                  </td>
                                                  <td>
                                                    {subItem.is_formulated_price ? (
                                                      <>{t('Formulated Price')}</>
                                                    ) : (
                                                      <>
                                                        {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                                          (i18next.language === 'en'
                                                            ? subItem.fixed_price?.toLocaleString(
                                                                'en',
                                                                {maximumFractionDigits: 4}
                                                              )
                                                            : subItem.fixed_price?.toLocaleString(
                                                                'id',
                                                                {maximumFractionDigits: 4}
                                                              )) +
                                                          (item.sector_id != 3 ? '/Ton' : '/MT')}
                                                      </>
                                                    )}
                                                  </td>
                                                </>
                                              )}
                                              {item.sector?.id == 1 || item.sector?.id == 3 ? (
                                                <></>
                                              ) : (
                                                <td>{subItem.plant + " - " + subItem.plant_desc}</td>
                                              )}
                                              <td>
                                                <button
                                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                  data-bs-toggle='tooltip'
                                                  data-bs-placement='top'
                                                  data-bs-trigger='hover'
                                                  title={t('Jadwal')}
                                                  onClick={() => {
                                                    setSektorID(subItem.sector_id)
                                                    setProvinceName(subItem.province?.region_name)
                                                    setCityName(subItem.city?.city_name)
                                                    setProductName(subItem.product_name)
                                                    formattingTon(subItem.fixed_quantum)
                                                    setReqeustQuantum(subItem.request_quantum)
                                                    setSubID(subItem.id)
                                                    sessionStorage.setItem('isCustomer', 'false')
                                                    setis_amandement(
                                                      subItem.is_new_item ? 'true' : 'false'
                                                    )
                                                    if (subItem.is_new_item)
                                                      handleShow2(0, subItem.id, 'true')
                                                    else handleShow2(subItem.id)
                                                  }}
                                                >
                                                  <KTSVG
                                                    path='/media/icons/duotune/calendar-check-fill.svg'
                                                    className='svg-icon-3'
                                                  />
                                                </button>
                                              </td>
                                              <td className='text-center'>
                                                <BadgeColorOrder
                                                  text={subItem?.status_text}
                                                  status={subItem?.status}
                                                  type='item'
                                                />
                                              </td>
                                            </>
                                          ) : (
                                            <>
                                              <td>
                                                <div className='d-flex justify-content-center align-items-center'>
                                                  <button
                                                    onClick={() => {
                                                      setis_amandement('true')
                                                      setTest(subItem.amendment_orders[0])
                                                      setTest2(subItem)
                                                      setSektorID(item.sector_id)
                                                      setShowEdit(true)
                                                      setRegarding(item.regarding)
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    hidden={hakAkses?.read ? false : true}
                                                    title='Detail'
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/file-text-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>

                                                  {/* <button
                                                    onClick={() => {
                                                      setis_amandement('true')
                                                      setDownloadOnly(false)
                                                      setParam('order-item')
                                                      tampilUpload(
                                                        subItem.amendment_orders[0]?.id,
                                                        'order-item',
                                                        subItem.id,
                                                        'true'
                                                      )
                                                      setFileBox(subItem.amendment_orders[0])
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('order-lampiran')}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/archive-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button> */}
                                                  <ShowAttachmentButton
                                                    item={subItem}
                                                    attachment_type={
                                                      subItem.is_new_item
                                                        ? 'amandemen'
                                                        : 'order-item'
                                                    }
                                                    isDownloadOnly={false}
                                                  />
                                                  <button
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('Tracking')}
                                                    hidden={roleUser == 'otorisator' ? true : false}
                                                    onClick={() => handleTracking(subItem.id)}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/tracking.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>
                                                  <DocFlow id={subItem.id} />
                                                  <ChatButton id={subItem.id} />
                                                </div>
                                              </td>
                                              <td>{_index + 1}</td>
                                              <td>{subItem.amendment_orders[0]?.produsen?.name}</td>
                                              {isRetail(subItem.sector_id) ? (
                                                <>
                                                  {subItem.amendment_orders[0]?.incoterm2 ==
                                                  null ? (
                                                    <td>
                                                      {subItem.amendment_orders[0]?.incoterm1?.code}
                                                      -{subItem.amendment_orders[0]?.incoterm2_id}
                                                    </td>
                                                  ) : (
                                                    <td>
                                                      {subItem.amendment_orders[0]?.incoterm1?.code}
                                                      -
                                                      {subItem.amendment_orders[0]?.incoterm2?.code}
                                                    </td>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  {subItem.amendment_orders[0]?.incoterm2 ==
                                                  null ? (
                                                    <td>
                                                      {subItem.amendment_orders[0]?.incoterm1?.code}
                                                      {subItem.amendment_orders[0]?.incoterm2_id ==
                                                        null ||
                                                      subItem.amendment_orders[0]?.incoterm2_id ==
                                                        '0'
                                                        ? ''
                                                        : '-' +
                                                          subItem.amendment_orders[0]?.incoterm2_id}
                                                    </td>
                                                  ) : (
                                                    <td>
                                                      {subItem.amendment_orders[0]?.incoterm1?.code}
                                                      -
                                                      {subItem.amendment_orders[0]?.incoterm2?.code}
                                                    </td>
                                                  )}
                                                </>
                                              )}

                                              <td>
                                                {subItem.amendment_orders[0]?.province?.region_name}
                                                {subItem.amendment_orders[0]?.city?.city_name
                                                  ? ', ' +
                                                    subItem.amendment_orders[0]?.city?.city_name
                                                  : ''}
                                              </td>

                                              <td>
                                                {subItem.amendment_orders[0]?.product_type_desc}
                                              </td>
                                              <td>
                                                {parseInt(
                                                  subItem.amendment_orders[0]?.material_number
                                                ) == 0
                                                  ? ''
                                                  : subItem.amendment_orders[0]?.material_number?.slice(
                                                      -7
                                                    )}
                                              </td>
                                              <td>{subItem.amendment_orders[0]?.product_name}</td>
                                              <td>
                                                <PopoverText
                                                  content={
                                                    subItem.amendment_orders[0]?.product_spec
                                                  }
                                                  index={_index}
                                                  className='spec-slice'
                                                />
                                              </td>
                                              {item.customer?.customer_account_group != 'AR03' ? (
                                                <>
                                                  <td>
                                                    {i18next.language === 'en'
                                                      ? subItem.amendment_orders[0]?.request_quantum?.toLocaleString(
                                                          'en',
                                                          {maximumFractionDigits: 4}
                                                        )
                                                      : subItem.amendment_orders[0]?.request_quantum?.toLocaleString(
                                                          'id',
                                                          {maximumFractionDigits: 4}
                                                        )}{' '}
                                                    {subItem.amendment_orders[0]?.sector_id === 3
                                                      ? 'MT'
                                                      : 'Ton'}
                                                  </td>
                                                  <td>
                                                    {subItem.amendment_orders[0]
                                                      ?.is_formulated_price ? (
                                                      <>{t('Formulated Price')}</>
                                                    ) : (
                                                      <>
                                                        {i18next.language === 'en'
                                                          ? parseFloat(
                                                              subItem.amendment_orders[0]
                                                                ?.request_price
                                                            )?.toLocaleString('en')
                                                          : parseFloat(
                                                              subItem.amendment_orders[0]
                                                                ?.request_price
                                                            )?.toLocaleString('id')}
                                                        /
                                                        {subItem.amendment_orders[0]?.sector_id ===
                                                        3
                                                          ? 'MT'
                                                          : 'Ton'}
                                                      </>
                                                    )}
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td>
                                                    {i18next.language === 'en'
                                                      ? subItem.amendment_orders[0]?.request_quantum?.toLocaleString(
                                                          'en',
                                                          {maximumFractionDigits: 4}
                                                        )
                                                      : subItem.amendment_orders[0]?.request_quantum?.toLocaleString(
                                                          'id',
                                                          {maximumFractionDigits: 4}
                                                        )}{' '}
                                                    {subItem.amendment_orders[0]?.sector_id === 3
                                                      ? 'MT'
                                                      : 'Ton'}
                                                  </td>
                                                  <td>
                                                    {subItem.amendment_orders[0]
                                                      ?.is_formulated_price ? (
                                                      <>{t('Formulated Price')}</>
                                                    ) : (
                                                      <>
                                                        {i18next.language === 'en'
                                                          ? parseFloat(
                                                              subItem.amendment_orders[0]
                                                                ?.request_price
                                                            ).toLocaleString('en')
                                                          : parseFloat(
                                                              subItem.amendment_orders[0]
                                                                ?.request_price
                                                            ).toLocaleString('id')}
                                                        /
                                                        {subItem.amendment_orders[0]?.sector_id ===
                                                        3
                                                          ? 'MT'
                                                          : 'Ton'}
                                                      </>
                                                    )}
                                                  </td>
                                                </>
                                              )}
                                              {item.sector?.id == 1 || item.sector?.id == 3 ? (
                                                <></>
                                              ) : (
                                                <td>{subItem.amendment_orders[0]?.plant_desc}</td>
                                              )}
                                              <td>
                                                <button
                                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                  data-bs-toggle='tooltip'
                                                  data-bs-placement='top'
                                                  data-bs-trigger='hover'
                                                  title={t('Jadwal')}
                                                  onClick={() => {
                                                    setSektorID(
                                                      subItem.amendment_orders[0]?.sector_id
                                                    )
                                                    setProvinceName(
                                                      subItem.amendment_orders[0]?.province
                                                        ?.region_name
                                                    )
                                                    setCityName(
                                                      subItem.amendment_orders[0]?.city?.city_name
                                                    )
                                                    setProductName(
                                                      subItem.amendment_orders[0]?.product_name
                                                    )
                                                    formattingTon(
                                                      subItem.amendment_orders[0]?.fixed_quantum
                                                    )
                                                    setReqeustQuantum(
                                                      subItem.amendment_orders[0]?.request_quantum
                                                    )
                                                    setSubID(subItem.amendment_orders[0]?.id)
                                                    sessionStorage.setItem('isCustomer', 'false')
                                                    setis_amandement('true')
                                                    handleShow2(
                                                      subItem.id,
                                                      subItem.amendment_orders[0]?.id,
                                                      'true'
                                                    )
                                                  }}
                                                >
                                                  <KTSVG
                                                    path='/media/icons/duotune/calendar-check-fill.svg'
                                                    className='svg-icon-3'
                                                  />
                                                </button>
                                              </td>
                                              <td className='text-center'>
                                                <BadgeColorOrder
                                                  text={subItem.amendment_orders[0]?.status_text}
                                                  status={subItem.amendment_orders[0]?.status}
                                                  type='item'
                                                />
                                              </td>
                                            </>
                                          )}
                                        </tr>
                                      ))}
                                    </TableUI.TBody>
                                  </>
                                ) : (
                                  <>
                                    {item.non_sales_regarding == 'INF-201' ||
                                    item.non_sales_regarding == 'INF-202' ? (
                                      <>
                                        <thead>
                                          <tr style={{backgroundColor: '#274070'}}>
                                            <th>{t('order-aksi')}</th>
                                            <th>{t('sub-order-item')}</th>
                                            <th>Sales Org</th>
                                            <th>{t('sub-order-incoterm')}</th>
                                            {item.sector_id != 3 ? (
                                              <th>{t('sub-order-wilayah')}</th>
                                            ) : (
                                              ''
                                            )}

                                            <th>{t('sub-order-jenis')}</th>
                                            <th>{t('Product Code')}</th>
                                            <th>{t('sub-order-produk')}</th>
                                            <th>{t('kontrak-kuantum')}</th>
                                            <th>{t('Harga')}</th>
                                            <th>Status</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item.children?.map((subItem: any, _index: any) => (
                                            <tr key={subItem?.id ?? _index}>
                                              <td>
                                                <div className='d-flex justify-content-center'>
                                                  <button
                                                    onClick={() => {
                                                      setis_amandement('false')
                                                      setTest(subItem)
                                                      setSektorID(item.sector_id)
                                                      setShowEdit(true)
                                                      setRegarding(item.regarding)
                                                      setNonPenjualan(item.non_sales_regarding)
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    hidden={hakAkses?.read ? false : true}
                                                    title='Detail'
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/file-text-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>

                                                  {/* <button
                                                    onClick={() => {
                                                      setis_amandement('false')
                                                      setDownloadOnly(false)
                                                      setParam('order-item')
                                                      tampilUpload(
                                                        subItem.id,
                                                        'order-item',
                                                        0,
                                                        'false'
                                                      )
                                                      setFileBox(subItem)
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('order-lampiran')}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/archive-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button> */}
                                                  <ShowAttachmentButton
                                                    item={subItem}
                                                    attachment_type={
                                                      subItem.is_new_item
                                                        ? 'amandemen'
                                                        : 'order-item'
                                                    }
                                                    isDownloadOnly={false}
                                                  />
                                                  <button
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('Tracking')}
                                                    hidden={
                                                      roleUser == 'otorisator' ||
                                                      hakAkses?.read == false
                                                        ? true
                                                        : false
                                                    }
                                                    onClick={() => handleTracking(subItem.id)}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/tracking.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>
                                                  <DocFlow id={subItem.id} />
                                                  <ChatButton id={subItem.id} />
                                                </div>
                                              </td>
                                              <td>{_index + 1}</td>
                                              <td>{subItem.produsen?.name}</td>
                                              <td>{subItem.incoterm1?.code}</td>
                                              <td>
                                                {subItem.province?.region_name},{' '}
                                                {subItem.city?.city_name}
                                              </td>
                                              <td>{subItem.product_type_desc}</td>
                                              <td>
                                                {parseInt(subItem.material_number) == 0
                                                  ? ''
                                                  : subItem.material_number.slice(-7)}
                                              </td>
                                              <td>{subItem.product_name}</td>
                                              <td>
                                                {i18next.language === 'en'
                                                  ? subItem.fixed_quantum?.toLocaleString('en', {
                                                      maximumFractionDigits: 4,
                                                    })
                                                  : subItem.fixed_quantum?.toLocaleString('id', {
                                                      maximumFractionDigits: 4,
                                                    })}{' '}
                                                {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                              </td>
                                              <td>
                                                {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                                  (i18next.language === 'en'
                                                    ? subItem.fixed_price?.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : subItem.fixed_price?.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })) +
                                                  (item.sector_id != 3 ? '/Ton' : '/MT')}
                                              </td>
                                              <td>
                                                <BadgeColorOrder
                                                  text={subItem?.status_text}
                                                  status={subItem?.status}
                                                  type='item'
                                                />
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </>
                                    ) : (
                                      <>
                                        <thead>
                                          <tr style={{backgroundColor: '#274070'}}>
                                            <th>{t('order-aksi')}</th>
                                            <th>{t('sub-order-item')}</th>
                                            <th>Sales Org</th>
                                            <th>{t('sub-order-jenis')}</th>
                                            <th>{t('Product Code')}</th>
                                            <th>{t('sub-order-produk')}</th>
                                            <th>Status</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item.children?.map((subItem: any, _index: any) => (
                                            <tr key={subItem?.product_name ?? _index}>
                                              <td>
                                                <div className='d-flex justify-content-center'>
                                                  <button
                                                    onClick={() => {
                                                      setis_amandement('false')
                                                      setTest(subItem)
                                                      setSektorID(item.sector_id)
                                                      setShowEdit(true)
                                                      setRegarding(item.regarding)
                                                      setNonPenjualan(item.non_sales_regarding)
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    hidden={hakAkses?.read ? false : true}
                                                    title='Detail'
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/file-text-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>

                                                  {/* <button
                                                    onClick={() => {
                                                      setis_amandement('false')
                                                      setDownloadOnly(false)
                                                      setParam('order-item')
                                                      tampilUpload(
                                                        subItem.id,
                                                        'order-item',
                                                        0,
                                                        'false'
                                                      )
                                                      setFileBox(subItem)
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('order-lampiran')}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/archive-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button> */}
                                                  <ShowAttachmentButton
                                                    item={subItem}
                                                    attachment_type={
                                                      subItem.is_new_item
                                                        ? 'amandemen'
                                                        : 'order-item'
                                                    }
                                                    isDownloadOnly={false}
                                                  />
                                                  <button
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('Tracking')}
                                                    hidden={
                                                      roleUser == 'otorisator' ||
                                                      hakAkses?.read == false
                                                        ? true
                                                        : false
                                                    }
                                                    onClick={() => handleTracking(subItem.id)}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/tracking.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>
                                                  <DocFlow id={subItem.id} />
                                                  <ChatButton id={subItem.id} />
                                                </div>
                                              </td>
                                              <td>{_index + 1}</td>
                                              <td>{subItem.produsen?.name}</td>
                                              <td>{subItem.product_type_desc}</td>
                                              <td>
                                                {parseInt(subItem.material_number) == 0
                                                  ? ''
                                                  : subItem.material_number.slice(-7)}
                                              </td>
                                              <td>{subItem.product_name}</td>
                                              <td>
                                                <BadgeColorOrder
                                                  text={subItem?.status_text}
                                                  status={subItem?.status}
                                                  type='item'
                                                />
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </>
                                    )}
                                  </>
                                )}
                              </TableUI.Table>
                            </TableUI.TableWrapper>
                          </TableUI.TableDetail>
                        </tr>
                      </Fragment>
                    ))
                  )}
                </TableUI.TBody>
              </TableUI.Table>
            </TableUI.TableWrapper>
          </>
        </>
      )}

      {(roleUser == 'salesAdmin' || roleUser == 'admin') && (
        <>
          <>
            <CardHeader
              right={
                <>
                  {hakAkses?.create && <AddOrderButton onClick={salesAdd} />}
                  {hakAkses?.export && (
                    <ExportOrderButton isLoading={loadingDownload} onClick={handleDownload} />
                  )}
                </>
              }
            />

            <TableUI.TableWrapper>
              <TableUI.Table>
                <TableUI.THead>
                  <RowHeadOrder />
                </TableUI.THead>

                <TableUI.TBody>
                  <RowFilterOrder />

                  {loading ? (
                    <TableLoader />
                  ) : isFailed ? (
                    <RowLoader />
                  ) : order.length === 0 ? (
                    <RowEmptyData />
                  ) : (
                    order.map((item, _index) => (
                      <>
                        <tr
                          className={
                            (hakAkses?.update || hakAkses?.approve) &&
                            item.status == 0 ||
                            item.status == 1 ||
                            item.amendment_submission == true
                              ? 'bg-kuning'
                              : ''
                          }
                        >
                          <td>
                            <div
                              className='d-flex p-0 justify-content-center'
                              style={{marginTop: '1px', marginBottom: '1.5px'}}
                            >
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title='Detail'
                                onClick={() => handleShow(item['id'], false)}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/file-text-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>

                              {item.amendment_submission && (
                                <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('approve-amandment')}
                                onClick={() => {
                                  handleShow(item['id'], item.amendment_submission)
                                }}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/check-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              )}

                              {/* <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('order-lampiran')}
                                onClick={() => {
                                  setis_amandement('false')
                                  setParam('header')
                                  setDownloadOnly(false)
                                  tampilUpload(item.id, 'header', 0, 'false')
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/archive-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button> */}
                              <ShowAttachmentButton
                                item={item}
                                attachment_type='header'
                                isDownloadOnly={false}
                              />
                              <ChatButton id={item.id} flag='order_sub_header' />

                              {item.has_item_negotiate && item.amendment_submission == false ? (
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('ke_nego')}
                                  onClick={() => {
                                    toNegoAll(item['id'], item['po_number'], item)
                                  }}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/handshake.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              ) : (
                                <></>
                              )}
                            </div>
                          </td>
                          <td>
                            <div
                              className='d-flex justify-content-evenly'
                              style={{marginTop: '-.5px', marginBottom: '-.5px'}}
                            >
                              <button
                                className='iconArow d-flex justify-content-start align-items-center'
                                data-target={'target' + item['id']}
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t(tooltip)}
                                onClick={handleOpen}
                              ></button>
                              <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={'/management/order/detail/' + item.id}
                              >
                                10{item['po_number']}
                              </Link>
                            </div>
                          </td>
                          <td>{dateformat(item.created_at)}</td>
                          <td>
                            <PopoverText
                              content={
                                item['customer']?.title == null || item.customer?.title == ''
                                  ? item['customer']?.name
                                  : item['customer']?.title + ' ' + item['customer']?.name
                              }
                              index={_index}
                              className='desc-slicee'
                            />
                          </td>
                          <td>
                            <span className='d-block fs-6'>{item.produsens_name.join(', ')}</span>
                          </td>
                          <td>
                            <span className='d-block fs-6'>
                              {item['regarding'] == 'PO001' ? (
                                <span className='badge badge-light-success'>{t('penjualan')}</span>
                              ) : (
                                <span className='badge badge-light-primary'>
                                  {t('Non-penjualan')}
                                </span>
                              )}
                            </span>
                          </td>
                          <td>
                            <span className='text-primary fw-bold d-block fs-6'>
                              {t(item.sector?.name)}
                            </span>
                          </td>
                          <td>
                            <span className='d-block fs-6'>
                              {item.regarding == 'PO001' ? (
                                <>
                                  {item.amendment_submission == false ? (
                                    <>
                                      {i18next.language === 'en'
                                        ? item.total_fixed_quantum.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : item.total_fixed_quantum.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {item.sector_id === 3 ? 'MT' : 'Ton'}
                                    </>
                                  ) : (
                                    <>
                                      {i18next.language === 'en'
                                        ? item.total_quantum_amandemen.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : item.total_quantum_amandemen.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {item.sector_id === 3 ? 'MT' : 'Ton'}
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {item.non_sales_regarding == 'INF-201' ||
                                  item.non_sales_regarding == 'INF-202' ? (
                                    <>
                                      {i18next.language === 'en'
                                        ? item.total_fixed_quantum.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : item.total_fixed_quantum.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {item.sector_id === 3 ? 'MT' : 'Ton'}
                                    </>
                                  ) : (
                                    ''
                                  )}
                                </>
                              )}
                            </span>
                          </td>
                          <td>
                            <span className='d-block fs-6'>
                              {item.regarding == 'PO001' ? (
                                <>
                                  {item.amendment_submission == false ? (
                                    <>
                                      {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                        (i18next.language === 'en'
                                          ? item.total_fixed_price_quantum?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : item.total_fixed_price_quantum?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }))}
                                    </>
                                  ) : (
                                    <>
                                      {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                        (i18next.language === 'en'
                                          ? item.total_price_amandemen?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : item.total_price_amandemen?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }))}
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {item.non_sales_regarding == 'INF-201' ||
                                  item.non_sales_regarding == 'INF-202' ? (
                                    <>
                                      {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                        (i18next.language === 'en'
                                          ? item.total_fixed_price_quantum?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : item.total_fixed_price_quantum?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }))}
                                    </>
                                  ) : (
                                    ''
                                  )}
                                </>
                              )}
                            </span>
                          </td>
                          <td>
                            <span className='d-block fs-6'>
                              <BadgeColorOrder
                                text={item?.status_text}
                                status={item?.status}
                                type='header'
                              />
                            </span>
                          </td>
                        </tr>

                        <tr className='fold' id={'target' + item['id']}>
                          <TableUI.TableDetail colSpan={10}>
                            <TableUI.TableWrapper style={{marginBottom: 0}}>
                              <TableUI.Table>
                                {isPurchase(item) ? (
                                  <>
                                    <TableUI.THead>
                                      <tr style={{backgroundColor: '#274070'}}>
                                        <th>{t('order-aksi')}</th>
                                        <th>{t('sub-order-item')}</th>
                                        {item.customer?.customer_account_group != 'AR03' ? (
                                          <>
                                            <th>Sales Org</th>
                                            <th>{t('sub-order-incoterm')}</th>
                                            <th>{t('sub-order-wilayah')}</th>
                                            <th>{t('sub-order-jenis')}</th>
                                            <th>{t('Product Code')}</th>
                                            <th>{t('sub-order-produk')}</th>
                                            <th>{t('sub-order-spek')}</th>
                                            <th>{t('kontrak-kuantum')}</th>
                                            <th>{t('Harga')}</th>
                                          </>
                                        ) : (
                                          <>
                                            <th>Sales Org</th>
                                            <th>{t('sub-order-incoterm')}</th>
                                            <th>{t('sub-order-wilayah')}</th>
                                            <th>{t('sub-order-jenis')}</th>
                                            <th>{t('Product Code')}</th>
                                            <th>{t('sub-order-produk')}</th>
                                            <th>{t('sub-order-spek')}</th>

                                            <th>{t('kontrak-kuantum')}</th>
                                            <th>{t('Harga')}</th>
                                          </>
                                        )}

                                        {item.sector?.id == 1 || item.sector?.id == 3 ? (
                                          <></>
                                        ) : (
                                          <th>{t('sub-order-gudang')}</th>
                                        )}
                                        <th>{t('sub-order-jadwalP')}</th>
                                        <th>Status</th>
                                      </tr>
                                    </TableUI.THead>
                                    <TableUI.TBody>
                                      {item['children']?.map((subItem: any, _index: any) => (
                                        <tr key={subItem?.id ?? _index}>
                                          {subItem.is_amendment == false ? (
                                            <>
                                              <td>
                                                <div className='d-flex justify-content-center align-items-center'>
                                                  <button
                                                    onClick={() => {
                                                      setis_amandement('false')
                                                      setTest(subItem)
                                                      setSektorID(item.sector_id)
                                                      setShowEdit(true)
                                                      setRegarding(item.regarding)
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    hidden={hakAkses?.read ? false : true}
                                                    title='Detail'
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/file-text-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>

                                                  {/* <button
                                                    onClick={() => {
                                                      setis_amandement('false')
                                                      setDownloadOnly(false)
                                                      setParam('order-item')
                                                      tampilUpload(
                                                        subItem.id,
                                                        'order-item',
                                                        0,
                                                        'false'
                                                      )
                                                      setFileBox(subItem)
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('order-lampiran')}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/archive-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button> */}
                                                  <ShowAttachmentButton
                                                    item={subItem}
                                                    attachment_type={
                                                      subItem.is_new_item
                                                        ? 'amandemen'
                                                        : 'order-item'
                                                    }
                                                    isDownloadOnly={false}
                                                  />

                                                  {(subItem.status == 3 || subItem.status == 5) &&
                                                  subItem.sales_id ==
                                                    localStorage.getItem('user-id') &&
                                                  subItem.is_amendment == false ? (
                                                    <button
                                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                      data-bs-toggle='tooltip'
                                                      data-bs-placement='top'
                                                      data-bs-trigger='hover'
                                                      title={t('ke_nego')}
                                                      onClick={() => {
                                                        toNego(subItem['id'], item['po_number'])
                                                      }}
                                                    >
                                                      <KTSVG
                                                        path='/media/icons/duotune/handshake.svg'
                                                        className='svg-icon-3'
                                                      />
                                                    </button>
                                                  ) : (
                                                    <></>
                                                  )}

                                                  <button
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('Tracking')}
                                                    hidden={hakAkses?.read ? false : true}
                                                    onClick={() => handleTracking(subItem.id)}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/tracking.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>
                                                  <DocFlow id={subItem.id} />
                                                  <ChatButton id={subItem.id} />
                                                </div>
                                              </td>
                                              <td>{_index + 1}</td>
                                              <td>{subItem.produsen?.name}</td>
                                              {isRetail(subItem.sector_id) ? (
                                                <>
                                                  {subItem.incoterm2 == null ? (
                                                    <td>
                                                      {subItem.incoterm1?.code}-
                                                      {subItem.incoterm2_id}
                                                    </td>
                                                  ) : (
                                                    <td>
                                                      {subItem.incoterm1?.code}-
                                                      {subItem.incoterm2?.code}
                                                    </td>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  {subItem.incoterm2 == null ? (
                                                    <td>
                                                      {subItem.incoterm1?.code}
                                                      {subItem.incoterm2_id == null ||
                                                      subItem.incoterm2_id == '0'
                                                        ? ''
                                                        : '-' + subItem.incoterm2_id}
                                                    </td>
                                                  ) : (
                                                    <td>
                                                      {subItem.incoterm1?.code}-
                                                      {subItem.incoterm2?.code}
                                                    </td>
                                                  )}
                                                </>
                                              )}

                                              <td>
                                                {subItem.province?.region_name}
                                                {subItem.city?.city_name
                                                  ? ', ' + subItem.city?.city_name
                                                  : ''}
                                              </td>

                                              <td>{subItem.product_type_desc}</td>
                                              <td>
                                                {parseInt(subItem.material_number) == 0
                                                  ? ''
                                                  : subItem.material_number.slice(-7)}
                                              </td>
                                              <td>{subItem.product_name}</td>
                                              <td>
                                                <PopoverText
                                                  content={subItem.product_spec}
                                                  index={_index}
                                                  className='spec-slice'
                                                />
                                              </td>
                                              {item.customer?.customer_account_group != 'AR03' ? (
                                                <>
                                                  <td>
                                                    {i18next.language === 'en'
                                                      ? subItem.fixed_quantum?.toLocaleString(
                                                          'en',
                                                          {maximumFractionDigits: 4}
                                                        )
                                                      : subItem.fixed_quantum?.toLocaleString(
                                                          'id',
                                                          {maximumFractionDigits: 4}
                                                        )}{' '}
                                                    {item.sector_id === 3 ? 'MT' : 'Ton'}
                                                  </td>
                                                  <td>
                                                    {subItem.is_formulated_price ? (
                                                      <>{t('Formulated Price')}</>
                                                    ) : (
                                                      <>
                                                        {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                                          (i18next.language === 'en'
                                                            ? subItem.fixed_price?.toLocaleString(
                                                                'en',
                                                                {maximumFractionDigits: 4}
                                                              )
                                                            : subItem.fixed_price?.toLocaleString(
                                                                'id',
                                                                {maximumFractionDigits: 4}
                                                              )) +
                                                          (item.sector_id != 3 ? '/Ton' : '/MT')}
                                                      </>
                                                    )}
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td>
                                                    {i18next.language === 'en'
                                                      ? subItem.fixed_quantum?.toLocaleString(
                                                          'en',
                                                          {maximumFractionDigits: 4}
                                                        )
                                                      : subItem.fixed_quantum?.toLocaleString(
                                                          'id',
                                                          {maximumFractionDigits: 4}
                                                        )}{' '}
                                                    {item.sector_id === 3 ? 'MT' : 'Ton'}
                                                  </td>
                                                  <td>
                                                    {subItem.is_formulated_price ? (
                                                      <>{t('Formulated Price')}</>
                                                    ) : (
                                                      <>
                                                        {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                                          (i18next.language === 'en'
                                                            ? subItem.fixed_price?.toLocaleString(
                                                                'en',
                                                                {maximumFractionDigits: 4}
                                                              )
                                                            : subItem.fixed_price?.toLocaleString(
                                                                'id',
                                                                {maximumFractionDigits: 4}
                                                              )) +
                                                          (item.sector_id != 3 ? '/Ton' : '/MT')}
                                                      </>
                                                    )}
                                                  </td>
                                                </>
                                              )}
                                              {item.sector?.id == 1 || item.sector?.id == 3 ? (
                                                <></>
                                              ) : (
                                                <td>{subItem.plant + " - " + subItem.plant_desc}</td>
                                              )}
                                              <td>
                                                <button
                                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                  data-bs-toggle='tooltip'
                                                  data-bs-placement='top'
                                                  data-bs-trigger='hover'
                                                  title={t('Jadwal')}
                                                  onClick={() => {
                                                    setSektorID(subItem.sector_id)
                                                    setProvinceName(subItem.province?.region_name)
                                                    setCityName(subItem.city?.city_name)
                                                    setProductName(subItem.product_name)
                                                    formattingTon(subItem.fixed_quantum)
                                                    setReqeustQuantum(subItem.request_quantum)
                                                    setSubID(subItem.id)
                                                    sessionStorage.setItem('isCustomer', 'false')
                                                    setis_amandement(
                                                      subItem.is_new_item ? 'true' : 'false'
                                                    )
                                                    if (subItem.is_new_item)
                                                      handleShow2(0, subItem.id, 'true')
                                                    else handleShow2(subItem.id)
                                                  }}
                                                >
                                                  <KTSVG
                                                    path='/media/icons/duotune/calendar-check-fill.svg'
                                                    className='svg-icon-3'
                                                  />
                                                </button>
                                              </td>
                                              <td>
                                                <BadgeColorOrder
                                                  text={subItem?.status_text}
                                                  status={subItem?.status}
                                                  type='item'
                                                />
                                              </td>
                                            </>
                                          ) : (
                                            <>
                                              <td>
                                                <div className='d-flex justify-content-center align-items-center'>
                                                  <button
                                                    onClick={() => {
                                                      setis_amandement('true')
                                                      setTest(subItem.amendment_orders[0])
                                                      setTest2(subItem)
                                                      setSektorID(item.sector_id)
                                                      setShowEdit(true)
                                                      setRegarding(item.regarding)
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    hidden={hakAkses?.read ? false : true}
                                                    title='Detail'
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/file-text-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>

                                                  {/* <button
                                                    onClick={() => {
                                                      setis_amandement('true')
                                                      setDownloadOnly(false)
                                                      setParam('order-item')
                                                      tampilUpload(
                                                        subItem.amendment_orders[0]?.id,
                                                        'order-item',
                                                        subItem.id,
                                                        'true'
                                                      )
                                                      setFileBox(subItem.amendment_orders[0])
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('order-lampiran')}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/archive-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button> */}
                                                  <ShowAttachmentButton
                                                    item={subItem}
                                                    attachment_type={
                                                      'amandemen'
                                                      // subItem.is_amandemen
                                                      //   ? 'amandemen'
                                                      //   : 'order-item'
                                                    }
                                                    isDownloadOnly={false}
                                                  />
                                                  <button
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('Tracking')}
                                                    onClick={() => handleTracking(subItem.id)}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/tracking.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>
                                                  <DocFlow id={subItem.id} />
                                                  <ChatButton id={subItem.id} />
                                                </div>
                                              </td>
                                              <td>{_index + 1}</td>
                                              <td>{subItem.amendment_orders[0]?.produsen?.name}</td>
                                              {isRetail(subItem.amendment_orders[0]?.sector_id) ? (
                                                <>
                                                  {subItem.amendment_orders[0]?.incoterm2 ==
                                                  null ? (
                                                    <td>
                                                      {subItem.amendment_orders[0]?.incoterm1?.code}
                                                      -{subItem.amendment_orders[0]?.incoterm2_id}
                                                    </td>
                                                  ) : (
                                                    <td>
                                                      {subItem.amendment_orders[0]?.incoterm1?.code}
                                                      -
                                                      {subItem.amendment_orders[0]?.incoterm2?.code}
                                                    </td>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  {subItem.amendment_orders[0]?.incoterm2 ==
                                                  null ? (
                                                    <td>
                                                      {subItem.amendment_orders[0]?.incoterm1?.code}
                                                      {subItem.amendment_orders[0]?.incoterm2_id ==
                                                        null ||
                                                      subItem.amendment_orders[0]?.incoterm2_id ==
                                                        '0'
                                                        ? ''
                                                        : '-' +
                                                          subItem.amendment_orders[0]?.incoterm2_id}
                                                    </td>
                                                  ) : (
                                                    <td>
                                                      {subItem.amendment_orders[0]?.incoterm1?.code}
                                                      -
                                                      {subItem.amendment_orders[0]?.incoterm2?.code}
                                                    </td>
                                                  )}
                                                </>
                                              )}
                                              <td>
                                                {subItem.amendment_orders[0]?.province?.region_name}
                                                {subItem.amendment_orders[0]?.city?.city_name
                                                  ? ', ' +
                                                    subItem.amendment_orders[0]?.city?.city_name
                                                  : ''}
                                              </td>
                                              <td>
                                                {subItem.amendment_orders[0]?.product_type_desc}
                                              </td>
                                              <td className='td-order-6 text-center'>
                                                {parseInt(
                                                  subItem.amendment_orders[0]?.material_number
                                                ) == 0
                                                  ? ''
                                                  : subItem.amendment_orders[0]?.material_number?.slice(
                                                      -7
                                                    )}
                                              </td>
                                              <td>{subItem.amendment_orders[0]?.product_name}</td>
                                              <td>
                                                <PopoverText
                                                  content={
                                                    subItem.amendment_orders[0]?.product_spec
                                                  }
                                                  index={_index}
                                                  className='spec-slice'
                                                />
                                              </td>
                                              {item.customer?.customer_account_group != 'AR03' ? (
                                                <>
                                                  <td>
                                                    {i18next.language === 'en'
                                                      ? subItem.amendment_orders[0]?.request_quantum?.toLocaleString(
                                                          'en',
                                                          {maximumFractionDigits: 4}
                                                        )
                                                      : subItem.amendment_orders[0]?.request_quantum?.toLocaleString(
                                                          'id',
                                                          {maximumFractionDigits: 4}
                                                        )}{' '}
                                                    {subItem.amendment_orders[0]?.sector_id === 3
                                                      ? 'MT'
                                                      : 'Ton'}
                                                  </td>
                                                  <td>
                                                    {subItem.amendment_orders[0]
                                                      ?.is_formulated_price ? (
                                                      <>{t('Formulated Price')}</>
                                                    ) : (
                                                      <>
                                                        {i18next.language === 'en'
                                                          ? subItem.amendment_orders[0]?.request_price?.toLocaleString(
                                                              'en'
                                                            )
                                                          : subItem.amendment_orders[0]?.request_price?.toLocaleString(
                                                              'id'
                                                            )}
                                                        /
                                                        {subItem.amendment_orders[0]?.sector_id ===
                                                        3
                                                          ? 'MT'
                                                          : 'Ton'}
                                                      </>
                                                    )}
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td>
                                                    {i18next.language === 'en'
                                                      ? subItem.amendment_orders[0]?.request_quantum?.toLocaleString(
                                                          'en',
                                                          {maximumFractionDigits: 4}
                                                        )
                                                      : subItem.amendment_orders[0]?.request_quantum?.toLocaleString(
                                                          'id',
                                                          {maximumFractionDigits: 4}
                                                        )}{' '}
                                                    {subItem.amendment_orders[0]?.sector_id === 3
                                                      ? 'MT'
                                                      : 'Ton'}
                                                  </td>
                                                  <td>
                                                    {subItem.amendment_orders[0]
                                                      ?.is_formulated_price ? (
                                                      <>{t('Formulated Price')}</>
                                                    ) : (
                                                      <>
                                                        {i18next.language === 'en'
                                                          ? subItem.amendment_orders[0]?.request_price.toLocaleString(
                                                              'en'
                                                            )
                                                          : subItem.amendment_orders[0]?.request_price.toLocaleString(
                                                              'id'
                                                            )}
                                                        /
                                                        {subItem.amendment_orders[0]?.sector_id ===
                                                        3
                                                          ? 'MT'
                                                          : 'Ton'}
                                                      </>
                                                    )}
                                                  </td>
                                                </>
                                              )}
                                              {item.sector?.id == 1 || item.sector?.id == 3 ? (
                                                <></>
                                              ) : (
                                                <td>{subItem.amendment_orders[0]?.plant_desc}</td>
                                              )}
                                              <td>
                                                <button
                                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                  data-bs-toggle='tooltip'
                                                  data-bs-placement='top'
                                                  data-bs-trigger='hover'
                                                  title={t('Jadwal')}
                                                  onClick={() => {
                                                    setSektorID(
                                                      subItem.amendment_orders[0]?.sector_id
                                                    )
                                                    setProvinceName(
                                                      subItem.amendment_orders[0]?.province
                                                        ?.region_name
                                                    )
                                                    setCityName(
                                                      subItem.amendment_orders[0]?.city?.city_name
                                                    )
                                                    setProductName(
                                                      subItem.amendment_orders[0]?.product_name
                                                    )
                                                    formattingTon(
                                                      subItem.amendment_orders[0]?.fixed_quantum
                                                    )
                                                    setReqeustQuantum(
                                                      subItem.amendment_orders[0]?.request_quantum
                                                    )
                                                    setSubID(subItem.amendment_orders[0]?.id)
                                                    sessionStorage.setItem('isCustomer', 'false')
                                                    setis_amandement('true')
                                                    handleShow2(
                                                      subItem.id,
                                                      subItem.amendment_orders[0]?.id,
                                                      'true'
                                                    )
                                                  }}
                                                >
                                                  <KTSVG
                                                    path='/media/icons/duotune/calendar-check-fill.svg'
                                                    className='svg-icon-3'
                                                  />
                                                </button>
                                              </td>
                                              <td className='text-center'>
                                                <BadgeColorOrder
                                                  text={subItem.amendment_orders[0]?.status_text}
                                                  status={subItem.amendment_orders[0]?.status}
                                                  type='item'
                                                />
                                              </td>
                                            </>
                                          )}
                                        </tr>
                                      ))}
                                    </TableUI.TBody>
                                  </>
                                ) : (
                                  <>
                                    {item.non_sales_regarding == 'INF-201' ||
                                    item.non_sales_regarding == 'INF-202' ? (
                                      <>
                                        <TableUI.THead>
                                          <tr style={{backgroundColor: '#274070'}}>
                                            <th>{t('order-aksi')}</th>
                                            <th>{t('sub-order-item')}</th>
                                            <th>Sales Org</th>
                                            <th>{t('sub-order-incoterm')}</th>
                                            {item.sector_id != 3 ? (
                                              <th>{t('sub-order-wilayah')}</th>
                                            ) : (
                                              ''
                                            )}

                                            <th>{t('sub-order-jenis')}</th>
                                            <th>{t('Product Code')}</th>
                                            <th>{t('sub-order-produk')}</th>
                                            <th>{t('kontrak-kuantum')}</th>
                                            <th>{t('Harga')}</th>
                                            <th>Status</th>
                                          </tr>
                                        </TableUI.THead>
                                        <TableUI.TBody>
                                          {item.children?.map((subItem: any, _index: any) => (
                                            <tr key={subItem?.id ?? _index}>
                                              <td>
                                                <div className='d-flex justify-content-center'>
                                                  <button
                                                    onClick={() => {
                                                      setis_amandement('false')
                                                      setTest(subItem)
                                                      setSektorID(item.sector_id)
                                                      setShowEdit(true)
                                                      setRegarding(item.regarding)
                                                      setNonPenjualan(item.non_sales_regarding)
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    hidden={hakAkses?.read ? false : true}
                                                    title='Detail'
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/file-text-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>

                                                  {/* <button
                                                    onClick={() => {
                                                      setis_amandement('false')
                                                      setDownloadOnly(true)
                                                      setParam('order-item')
                                                      tampilUpload(
                                                        subItem.id,
                                                        'order-item',
                                                        0,
                                                        'false'
                                                      )
                                                      setFileBox(subItem)
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('order-lampiran')}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/archive-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button> */}
                                                  <ShowAttachmentButton
                                                    item={subItem}
                                                    attachment_type={
                                                      subItem.is_new_item
                                                        ? 'amandemen'
                                                        : 'order-item'
                                                    }
                                                    isDownloadOnly={false}
                                                  />
                                                  <DocFlow id={subItem.id} />
                                                  <ChatButton id={subItem.id} />

                                                  <button
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('Tracking')}
                                                    onClick={() => handleTracking(subItem.id)}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/tracking.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>
                                                </div>
                                              </td>
                                              <td>{_index + 1}</td>
                                              <td>{subItem.produsen?.name}</td>
                                              <td>{subItem.incoterm1?.code}</td>
                                              {item.sector_id != 3 ? (
                                                <td>
                                                  {subItem.province?.region_name},{' '}
                                                  {subItem.city?.city_name}
                                                </td>
                                              ) : (
                                                ''
                                              )}
                                              <td>{subItem.product_type_desc}</td>
                                              <td>
                                                {parseInt(subItem.material_number) == 0
                                                  ? ''
                                                  : subItem.material_number.slice(-7)}
                                              </td>
                                              <td>{subItem.product_name}</td>
                                              <td>
                                                {i18next.language === 'en'
                                                  ? subItem.fixed_quantum?.toLocaleString('en', {
                                                      maximumFractionDigits: 4,
                                                    })
                                                  : subItem.fixed_quantum?.toLocaleString('id', {
                                                      maximumFractionDigits: 4,
                                                    })}{' '}
                                                {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                              </td>
                                              <td>
                                                {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                                  (i18next.language === 'en'
                                                    ? subItem.fixed_price?.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : subItem.fixed_price?.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })) +
                                                  (item.sector_id != 3 ? '/Ton' : '/MT')}
                                              </td>
                                              <td>
                                                <BadgeColorOrder
                                                  text={subItem?.status_text}
                                                  status={subItem?.status}
                                                  type='item'
                                                />
                                              </td>
                                            </tr>
                                          ))}
                                        </TableUI.TBody>
                                      </>
                                    ) : (
                                      <>
                                        <TableUI.THead>
                                          <tr style={{backgroundColor: '#274070'}}>
                                            <th>{t('order-aksi')}</th>
                                            <th>{t('sub-order-item')}</th>
                                            <th>Sales Org</th>
                                            <th>{t('sub-order-jenis')}</th>
                                            <th>{t('Product Code')}</th>
                                            <th>{t('sub-order-produk')}</th>
                                            <th>Status</th>
                                          </tr>
                                        </TableUI.THead>
                                        <TableUI.TBody>
                                          {item.children?.map((subItem: any, _index: any) => (
                                            <tr key={subItem?.product_name ?? _index}>
                                              <td>
                                                <div className='d-flex justify-content-center'>
                                                  <button
                                                    onClick={() => {
                                                      setis_amandement('false')
                                                      setTest(subItem)
                                                      setSektorID(item.sector_id)
                                                      setShowEdit(true)
                                                      setRegarding(item.regarding)
                                                      setNonPenjualan(item.non_sales_regarding)
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    hidden={hakAkses?.read ? false : true}
                                                    title='Detail'
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/file-text-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>

                                                  {/* <button
                                                    onClick={() => {
                                                      setis_amandement('false')
                                                      setDownloadOnly(true)
                                                      setParam('order-item')
                                                      tampilUpload(
                                                        subItem.id,
                                                        'order-item',
                                                        0,
                                                        'false'
                                                      )
                                                      setFileBox(subItem)
                                                    }}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('order-lampiran')}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/archive-fill.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button> */}
                                                  <ShowAttachmentButton
                                                    item={subItem}
                                                    attachment_type={
                                                      subItem.is_new_item
                                                        ? 'amandemen'
                                                        : 'order-item'
                                                    }
                                                    isDownloadOnly={false}
                                                  />
                                                  <DocFlow id={subItem.id} />
                                                  <ChatButton id={subItem.id} />

                                                  <button
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    data-bs-toggle='tooltip'
                                                    data-bs-placement='top'
                                                    data-bs-trigger='hover'
                                                    title={t('Tracking')}
                                                    onClick={() => handleTracking(subItem.id)}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/tracking.svg'
                                                      className='svg-icon-3'
                                                    />
                                                  </button>
                                                </div>
                                              </td>
                                              <td>{_index + 1}</td>
                                              <td>{subItem.produsen?.name}</td>
                                              <td>{subItem.product_type_desc}</td>
                                              <td>
                                                {parseInt(subItem.material_number) == 0
                                                  ? ''
                                                  : subItem.material_number.slice(-7)}
                                              </td>
                                              <td>{subItem.product_name}</td>
                                              <td>
                                                <BadgeColorOrder
                                                  text={subItem?.status_text}
                                                  status={subItem?.status}
                                                  type='item'
                                                />
                                              </td>
                                            </tr>
                                          ))}
                                        </TableUI.TBody>
                                      </>
                                    )}
                                  </>
                                )}
                              </TableUI.Table>
                            </TableUI.TableWrapper>
                          </TableUI.TableDetail>
                        </tr>
                      </>
                    ))
                  )}
                </TableUI.TBody>
              </TableUI.Table>
            </TableUI.TableWrapper>
          </>
        </>
      )}

      <Modal
        show={showJadwal}
        onHide={() => {
          setShowJadwal(false)
          sessionStorage.removeItem('isCustomer')
        }}
        centered
        size='xl'
        backdrop='static'
        keyboard={false}
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {sektorID != '3' ? provinceName + ', ' + cityName + ' | ' : ''}
            {productName} | {fixedQuantum} Ton
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div hidden={is_amandemen == 'false' ? false : true}>
            <span style={{fontSize: '15px'}} className='fw-bold d-block'>
              {t('Jadwal')}
            </span>
            <AddRemoveJadwal id={subID} is_amendment={is_amandemen} />
          </div>
          <div hidden={is_amandemen == 'true' ? false : true}>
            <span style={{fontSize: '15px'}} className='fw-bold d-block'>
              {t('Jadwal')}
            </span>
            {isLoadingSchedule ? (
              <SkeletonSchedule />
            ) : allJadwal.length < 1 ? (
              <div className='text-center fs-4 fw-semibold'>{t('no schedule')}</div>
            ) : (
              <div className='table-responsive bdr mt-2'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='border-bottom'>
                    <tr className='fw-bold '>
                      <th className='text-center'>{t('order-pengambilan')}</th>
                      <th className='text-center'>{t('order-minggu')}</th>
                      <th className='text-center'>{t('order-bulan')}</th>
                      <th className='text-center'>{t('order-tahun')}</th>
                      <th className='text-center'>{t('order-tonase')}</th>
                    </tr>
                  </thead>
                  {allJadwal.map((data, _index) => (
                    <tbody key={data?.week ?? _index}>
                      <tr className=''>
                        <td className='text-center'>
                          <label>{_index + 1}</label>
                        </td>
                        <td className='text-center'>
                          <label>
                            {t('Week')}{Math.ceil(data.date / 7)}
                          </label>
                        </td>
                        <td className='text-center'>
                          <label>{t(bulan[data.month - 1])}</label>
                        </td>
                        <td className='text-center'>
                          <label>{data.year}</label>
                        </td>
                        <td className='text-center'>
                          <label>
                            {(i18next.language === 'en'
                              ? data.tonnage.toLocaleString('en', {maximumFractionDigits: 4})
                              : data.tonnage.toLocaleString('id', {maximumFractionDigits: 4})) +
                              ' ' +
                              'Ton'}
                          </label>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showEdit}
        onHide={() => {
          setShowEdit(false)
        }}
        centered
        scrollable
        backdrop='static'
        size={'xl'}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Detail Sub Order')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showPurchaseForm ? (
            <>
              {is_amandemen == 'true' ? (
                <>
                  {test.sector_id == 1 && (
                    <Row>
                      <Col md='6'>
                        <h5 className='mb-3 text-danger'>{t('Before')}</h5>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>Sales Orgs</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2?.produsen?.name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={t(test2?.sector?.name)}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2?.incoterm1?.code}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col md={8}>
                            {test2?.incoterm2 == null ? (
                              <Form.Control
                                value={
                                  test2?.incoterm2_id == null || test2?.incoterm2_id == '0'
                                    ? ''
                                    : test2?.incoterm2_id
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            ) : (
                              <Form.Control
                                value={test2?.incoterm2?.code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              type='text'
                              value={test2.province?.region_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              type='text'
                              value={test2.city?.city_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2.product_type_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2.product_name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                          </Col>
                          <Col md={8}>
                            {test2.so_qty_realized == undefined ? (
                              <Form.Control
                                value={
                                  i18next.language === 'en'
                                    ? parseFloat(test2?.fixed_quantum).toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      }) + ' Ton'
                                    : parseFloat(test2?.fixed_quantum).toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      }) + ' Ton'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            ) : (
                              <Form.Control
                                value={
                                  i18next.language === 'en'
                                    ? (
                                        parseFloat(test2?.fixed_quantum) -
                                        parseFloat(test2.so_qty_realized)
                                      ).toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      }) + ' Ton'
                                    : (
                                        parseFloat(test2?.fixed_quantum) -
                                        parseFloat(test2.so_qty_realized)
                                      ).toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      }) + ' Ton'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-2'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('Harga Pengajuan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={
                                'Rp' + i18next.language === 'en'
                                  ? parseInt(test2?.fixed_price).toLocaleString('en') + '/Ton'
                                  : parseInt(test2?.fixed_price).toLocaleString('id') + '/Ton'
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                          </Col>
                          <Col sm={8} className='d-flex justify-content-start'>
                            <Form.Check
                              reverse
                              name='ppn'
                              className='mt-5 mb-2'
                              type='checkbox'
                              id='ckbox-ppn'
                              checked={test2?.include_ppn}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('Shipping Tolerance')}</p>
                          </Col>
                          <Col sm={8} className='d-flex justify-content-start'>
                            <Form.Control
                              type='text'
                              disabled
                              size='sm'
                              value={
                                test2?.shipping_tolerance == 0
                                  ? ''
                                  : test2?.shipping_tolerance + '%'
                              }
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2?.payment_type_1_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2?.payment_type_2_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            {i18next.language === 'en' ? (
                              <p className='fs-6 mt-3'>{t('keterangan')}</p>
                            ) : (
                              <p className='fs-6'>{t('keterangan')}</p>
                            )}
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2?.payment_note}
                              type='text'
                              as='textarea'
                              style={{height: '40px'}}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2.product_spec}
                              as='textarea'
                              style={{height: '40px'}}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('segment')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              type='text'
                              value={t(test2.segment_name)}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('End Customer')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={
                                test2.end_user_multiple
                                  ? handleShowValue(test2.end_user)
                                  : test2.end_user
                                // test2?.end_user_detail?.name
                                //   ? test2?.end_user_detail?.name
                                //   : test2?.end_user
                              }
                              as='textarea'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2?.notes}
                              type='text'
                              as='textarea'
                              style={{height: '40px'}}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        { !isRetail(test2?.sector_id) && <>
                          <Row
                            className='mb-4'
                          >
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('alasan perpanjangan')}
                                defaultValue={test2?.amandement_notes || '-'}
                                disabled
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                              />
                            </Col>
                          </Row>
                          <Row
                            className='mb-4'
                          >
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('tanggal perpanjangan')}
                                defaultValue={test2?.extension_date ? moment(test2?.extension_date).format('DD/MM/YYYY') : '-'}
                                disabled
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                              />
                            </Col>
                          </Row>
                        </> }
                      </Col>
                      <Col md='6'>
                        <h5 className='mb-3' style={{color: '#2664b5'}}>
                          {t('After')}
                        </h5>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>Sales Org</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test.produsen?.name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={t(test.sector?.name)}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test.incoterm1?.code}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col md={8}>
                            {test?.incoterm2 == null ? (
                              <Form.Control
                                value={
                                  test?.incoterm2_id == null || test?.incoterm2_id == '0'
                                    ? ''
                                    : test?.incoterm2_id
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            ) : (
                              <Form.Control
                                value={test?.incoterm2?.code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              type='text'
                              value={test.province?.region_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              type='text'
                              value={test.city?.city_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        {/* <Row className='mb-4'>
              <Col md={4}>
                <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
              </Col>
              <Col md={8}>
                <Form.Control type='text' value={test.plant_desc} disabled size='sm' />
              </Col>
            </Row> */}
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test.product_type_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test.product_name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={
                                i18next.language === 'en'
                                  ? (
                                      parseFloat(test.fixed_quantum) -
                                      parseFloat(test.so_qty_realized)
                                    )?.toLocaleString('en', {maximumFractionDigits: 4}) + ' Ton'
                                  : (
                                      parseFloat(test.fixed_quantum) -
                                      parseFloat(test.so_qty_realized)
                                    )?.toLocaleString('id', {maximumFractionDigits: 4}) + ' Ton'
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-2'>
                          <Col md={4}>
                            <p className='fs-6 mt-3'>{t('Harga Pengajuan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={
                                'Rp' + i18next.language === 'en'
                                  ? parseInt(test?.fixed_price).toLocaleString('en') + '/Ton'
                                  : parseInt(test?.fixed_price).toLocaleString('id') + '/Ton'
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                          </Col>
                          <Col sm={8} className='d-flex justify-content-start'>
                            <Form.Check
                              reverse
                              name='ppn'
                              className='mt-5 mb-2'
                              type='checkbox'
                              id='ckbox-ppn'
                              checked={test?.include_ppn}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                          </Col>
                          <Col sm={8} className='d-flex justify-content-start'>
                            <Form.Control
                              type='text'
                              disabled
                              size='sm'
                              value={
                                test?.shipping_tolerance == 0 ? '' : test?.shipping_tolerance + '%'
                              }
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test?.payment_type_1_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test?.payment_type_2_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            {i18next.language === 'en' ? (
                              <p className='fs-6 mt-3'>{t('keterangan')}</p>
                            ) : (
                              <p className='fs-6'>{t('keterangan')}</p>
                            )}
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test?.payment_note}
                              type='text'
                              as='textarea'
                              style={{height: '40px'}}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test.product_spec}
                              as='textarea'
                              style={{height: '40px'}}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('segment')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              type='text'
                              value={t(test.segment_name)}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('End Customer')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={
                                test.end_user_multiple
                                  ? handleShowValue(test.end_user)
                                  : test.end_user
                              }
                              as='textarea'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test?.notes}
                              type='text'
                              as='textarea'
                              style={{height: '40px'}}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        { !isRetail(test?.sector_id) && <>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as='textarea'
                                defaultValue={test?.amandement_notes}
                                disabled
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                              />
                            </Col>
                          </Row>
                          <Row
                            className='mb-4'
                          >
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as='textarea'
                                defaultValue={test?.extension_date ? moment(test?.extension_date).format('DD/MM/YYYY') : ''}
                                disabled
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                              />
                            </Col>
                          </Row>
                        </> }
                      </Col>
                    </Row>
                  )}

                  {test.sector_id == 3 && (
                    <Row>
                      <Col md='6'>
                        <h5 className='mb-3 text-danger'>{t('Before')}</h5>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>Sales Org</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2.produsen?.name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={t(test2.sector?.name)}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2.incoterm1?.code}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col md={8}>
                            {test2?.incoterm2 == null ? (
                              <Form.Control
                                value={
                                  test2?.incoterm2_id == null || test2?.incoterm2_id == '0'
                                    ? ''
                                    : test2?.incoterm2_id
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            ) : (
                              <Form.Control
                                value={test2?.incoterm2?.code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              type='text'
                              value={test2.province?.region_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              type='text'
                              value={test2.city?.city_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        {/* <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control type='text' value={test2.plant_desc} disabled size='sm' />
                          </Col>
                        </Row> */}
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2.product_type_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2.product_name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                          </Col>
                          <Col md={8}>
                            {test2.so_qty_realized == undefined ? (
                              <Form.Control
                                value={
                                  i18next.language === 'en'
                                    ? parseFloat(test2?.fixed_quantum).toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      }) + ' MT'
                                    : parseFloat(test2?.fixed_quantum).toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      }) + ' MT'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            ) : (
                              <Form.Control
                                value={
                                  i18next.language === 'en'
                                    ? (
                                        parseFloat(test2?.fixed_quantum) -
                                        parseFloat(test2.so_qty_realized)
                                      ).toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      }) + ' MT'
                                    : (
                                        parseFloat(test2?.fixed_quantum) -
                                        parseFloat(test2.so_qty_realized)
                                      ).toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      }) + ' MT'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-2'>
                          <Col md={4}>
                            <p className='fs-6 mt-3'>{t('Harga Pengajuan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={
                                'USD' + i18next.language === 'en'
                                  ? parseFloat(test2?.fixed_price).toLocaleString('en', {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 2,
                                    }) + '/MT'
                                  : parseFloat(test2?.fixed_price).toLocaleString('id', {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 2,
                                    }) + '/MT'
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        {/* <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                          </Col>
                          <Col sm={8} className='d-flex justify-content-start'>
                            <Form.Check
                              reverse
                              name='ppn'
                              className='mt-5 mb-2'
                              type='checkbox'
                              id='ckbox-ppn'
                              checked={test2?.include_ppn}
                            />
                          </Col>
                        </Row> */}
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('Shipping Tolerance')}</p>
                          </Col>
                          <Col sm={8} className='d-flex justify-content-start'>
                            <Form.Control
                              type='text'
                              disabled
                              size='sm'
                              value={
                                test2?.shipping_tolerance == 0
                                  ? ''
                                  : test2?.shipping_tolerance + '%'
                              }
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2?.payment_type_1_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2?.payment_type_2_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            {i18next.language === 'en' ? (
                              <p className='fs-6 mt-3'>{t('keterangan')}</p>
                            ) : (
                              <p className='fs-6'>{t('keterangan')}</p>
                            )}
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2?.payment_note}
                              type='text'
                              as='textarea'
                              style={{height: '40px'}}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2.product_spec}
                              as='textarea'
                              style={{height: '40px'}}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('End Customer')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={
                                test2.end_user_multiple
                                  ? handleShowValue(test2.end_user)
                                  : test2.end_user
                              }
                              as='textarea'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test2?.notes}
                              type='text'
                              as='textarea'
                              style={{height: '40px'}}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        { !isRetail(test2?.sector_id) && <>
                          <Row
                            className='mb-4'
                          >
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('alasan perpanjangan')}
                                defaultValue={test2?.amandement_notes || '-'}
                                disabled
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                              />
                            </Col>
                          </Row>
                          <Row
                            className='mb-4'
                          >
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('tanggal perpanjangan')}
                                defaultValue={test2?.extension_date ? moment(test2?.extension_date).format('DD/MM/YYYY') : '-'}
                                disabled
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                              />
                            </Col>
                          </Row>
                        </> }
                      </Col>
                      <Col md='6'>
                        <h5 className='mb-3' style={{color: '#2664b5'}}>
                          {t('After')}
                        </h5>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>Sales Org</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test.produsen?.name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={t(test.sector?.name)}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test.incoterm1?.code}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col md={8}>
                            {test?.incoterm2 == null ? (
                              <Form.Control
                                value={
                                  test?.incoterm2_id == null || test?.incoterm2_id == '0'
                                    ? ''
                                    : test?.incoterm2_id
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            ) : (
                              <Form.Control
                                value={test?.incoterm2?.code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              type='text'
                              value={test.province?.region_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              type='text'
                              value={test.city?.city_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        {/* <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                          </Col>
                          <Col md={6}>
                            <Form.Control type='text' value={test.plant_desc} disabled size='sm' />
                          </Col>
                        </Row> */}
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test.product_type_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test.product_name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={
                                i18next.language === 'en'
                                  ? (
                                      parseFloat(test.fixed_quantum) -
                                      parseFloat(test.so_qty_realized)
                                    )?.toLocaleString('en', {maximumFractionDigits: 4}) + ' MT'
                                  : (
                                      parseFloat(test.fixed_quantum) -
                                      parseFloat(test.so_qty_realized)
                                    )?.toLocaleString('id', {maximumFractionDigits: 4}) + ' MT'
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-2'>
                          <Col md={4}>
                            <p className='fs-6 mt-3'>{t('Harga Pengajuan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={
                                'USD' + i18next.language === 'en'
                                  ? parseFloat(test?.fixed_price).toLocaleString('en', {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 2,
                                    }) + '/MT'
                                  : parseFloat(test?.fixed_price).toLocaleString('id', {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 2,
                                    }) + '/MT'
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        {/* <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                          </Col>
                          <Col sm={8} className='d-flex justify-content-start'>
                            <Form.Check
                              reverse
                              name='ppn'
                              className='mt-5 mb-2'
                              type='checkbox'
                              id='ckbox-ppn'
                              checked={test?.include_ppn}
                            />
                          </Col>
                        </Row> */}
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                          </Col>
                          <Col sm={8} className='d-flex justify-content-start'>
                            <Form.Control
                              disabled
                              type='text'
                              size='sm'
                              value={
                                test?.shipping_tolerance == 0 ? '' : test?.shipping_tolerance + '%'
                              }
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test?.payment_type_1_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test?.payment_type_2_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            {i18next.language === 'en' ? (
                              <p className='fs-6 mt-3'>{t('keterangan')}</p>
                            ) : (
                              <p className='fs-6'>{t('keterangan')}</p>
                            )}
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test?.payment_note}
                              type='text'
                              as='textarea'
                              style={{height: '40px'}}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test.product_spec}
                              as='textarea'
                              style={{height: '40px'}}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('End Customer')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={
                                test.end_user_multiple
                                  ? handleShowValue(test.end_user)
                                  : test.end_user
                              }
                              as='textarea'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={test?.notes}
                              type='text'
                              as='textarea'
                              style={{height: '40px'}}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        { !isRetail(test?.sector_id) && <>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as='textarea'
                                defaultValue={test?.amandement_notes}
                                disabled
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                              />
                            </Col>
                          </Row>
                          <Row
                            className='mb-4'
                          >
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as='textarea'
                                defaultValue={test?.extension_date ? moment(test?.extension_date).format('DD/MM/YYYY') : ''}
                                disabled
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                              />
                            </Col>
                          </Row>
                        </> }
                      </Col>
                    </Row>
                  )}
                </>
              ) : (
                <>
                  {test?.amendment == true ? (
                    <>
                      {test?.sector_id == 1 && (
                        <Row>
                          <Col md='6'>
                            <h5 className='mb-3'>Before</h5>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>Sales Org</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.produsen?.name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={t(test.sector?.name)}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.incoterm1?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                              </Col>
                              <Col md={8}>
                                {test?.incoterm2 == null ? (
                                  <Form.Control
                                    value={
                                      test?.incoterm2_id == null || test?.incoterm2_id == '0'
                                        ? ''
                                        : test?.incoterm2_id
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                ) : (
                                  <Form.Control
                                    value={test?.incoterm2?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                )}
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.province?.region_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.city?.city_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_type_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    i18next.language === 'en'
                                      ? parseFloat(test?.request_quantum).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                      : parseFloat(test?.request_quantum).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('Kuantum Disetujui')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    i18next.language === 'en'
                                      ? parseFloat(test?.fixed_quantum).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                      : parseFloat(test?.fixed_quantum).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-2'>
                              <Col md={4}>
                                <p className='fs-6 mt-3'>{t('Harga Pengajuan')}/Ton</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    'Rp' + i18next.language === 'en'
                                      ? parseInt(test?.request_price).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : parseInt(test?.request_price).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-2'>
                              <Col md={4}>
                                <p className='fs-6 mt-3'>{t('Harga Disetujui')}/Ton</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    'Rp' + i18next.language === 'en'
                                      ? parseInt(test?.fixed_price).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : parseInt(test?.fixed_price).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                              </Col>
                              <Col sm={8} className='d-flex justify-content-start'>
                                <Form.Check
                                  reverse
                                  name='ppn'
                                  className='mt-5 mb-2'
                                  type='checkbox'
                                  id='ckbox-ppn'
                                  checked={test?.include_ppn}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_type_1_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_type_2_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='fs-6'>{t('keterangan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_note}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_spec}
                                  as='textarea'
                                  style={{height: '40px'}}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('End Customer')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    test.end_user_multiple
                                      ? handleShowValue(test.end_user)
                                      : test.end_user
                                  }
                                  as='textarea'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.notes}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            { !isRetail(test?.sector_id) && <>
                              <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as='textarea'
                                defaultValue={test?.amandement_notes}
                                disabled
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                              />
                            </Col>
                          </Row>
                          <Row
                            className='mb-4'
                          >
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as='textarea'
                                defaultValue={test?.extension_date ? moment(test?.extension_date).format('DD/MM/YYYY') : ''}
                                disabled
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                              />
                            </Col>
                          </Row>
                            </> }
                          </Col>
                          <Col md='6'>
                            <h5 className='mb-3'>After</h5>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>Sales Org</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.produsen?.name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={t(test.sector?.name)}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.incoterm1?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                              </Col>
                              <Col md={8}>
                                {test?.incoterm2 == null ? (
                                  <Form.Control
                                    value={
                                      test?.incoterm2_id == null || test?.incoterm2_id == '0'
                                        ? ''
                                        : test?.incoterm2_id
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                ) : (
                                  <Form.Control
                                    value={test?.incoterm2?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                )}
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.province?.region_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.city?.city_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_type_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    i18next.language === 'en'
                                      ? parseFloat(test?.fixed_quantum).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                      : parseFloat(test?.fixed_quantum).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-2'>
                              <Col md={4}>
                                <p className='fs-6 mt-3'>{t('Harga Pengajuan')}/Ton</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    'Rp' + i18next.language === 'en'
                                      ? parseInt(test?.fixed_price).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : parseInt(test?.fixed_price).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                              </Col>
                              <Col sm={8} className='d-flex justify-content-start'>
                                <Form.Check
                                  reverse
                                  name='ppn'
                                  className='mt-5 mb-2'
                                  type='checkbox'
                                  id='ckbox-ppn'
                                  checked={test?.include_ppn}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_type_1_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_type_2_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='fs-6'>{t('keterangan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_note}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_spec}
                                  as='textarea'
                                  style={{height: '40px'}}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('End Customer')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    test.end_user_multiple
                                      ? handleShowValue(test.end_user)
                                      : test.end_user
                                  }
                                  as='textarea'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.notes}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            { !isRetail(test?.sector_id) && <>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    as='textarea'
                                    defaultValue={test?.amandement_notes}
                                    disabled
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                  />
                                </Col>
                              </Row>
                              <Row
                                className='mb-4'
                              >
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    as='textarea'
                                    defaultValue={test?.extension_date ? moment(test?.extension_date).format('DD/MM/YYYY') : ''}
                                    disabled
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                  />
                                </Col>
                              </Row>
                            </> }
                          </Col>
                        </Row>
                      )}

                      {isRetail(test?.sector_id) && (
                        <Row>
                          <Col md='6'>
                            <h5 className='mb-3'>Before</h5>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>Sales Org</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.produsen?.name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={t(test.sector?.name)}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.incoterm1?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                              </Col>
                              <Col md={8}>
                                {test?.incoterm2 == null ? (
                                  <Form.Control
                                    value={
                                      test?.incoterm2_id == null || test?.incoterm2_id == '0'
                                        ? ''
                                        : test?.incoterm2_id
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                ) : (
                                  <Form.Control
                                    value={test?.incoterm2?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                )}
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.province?.region_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.city?.city_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.plant_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_type_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_spec}
                                  as='textarea'
                                  style={{height: '40px'}}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    i18next.language === 'en'
                                      ? parseFloat(test?.fixed_quantum).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                      : parseFloat(test?.fixed_quantum).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='fs-6 mt-3'>{t('Price')}/Ton</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    'Rp' + i18next.language === 'en'
                                      ? parseInt(test?.fixed_price).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : parseInt(test?.fixed_price).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_type_1_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row
                              className='mb-4'
                              hidden={roleUser == 'null' || roleUser == null ? true : false}
                            >
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('End Customer')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    test.end_user_multiple
                                      ? handleShowValue(test.end_user)
                                      : test.end_user
                                  }
                                  as='textarea'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='fs-6'>{t('keterangan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_note}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.notes}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col md='6'>
                            <h5 className='mb-3'>After</h5>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>Sales Org</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.produsen?.name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={t(test.sector?.name)}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.incoterm1?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                              </Col>
                              <Col md={8}>
                                {test?.incoterm2 == null ? (
                                  <Form.Control
                                    value={
                                      test?.incoterm2_id == null || test?.incoterm2_id == '0'
                                        ? ''
                                        : test?.incoterm2_id
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                ) : (
                                  <Form.Control
                                    value={test?.incoterm2?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                )}
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.province?.region_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.city?.city_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.plant_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_type_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_spec}
                                  as='textarea'
                                  style={{height: '40px'}}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    i18next.language === 'en'
                                      ? parseFloat(test?.fixed_quantum).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                      : parseFloat(test?.fixed_quantum).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='fs-6 mt-3'>{t('Price')}/Ton</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    'Rp' + i18next.language === 'en'
                                      ? parseInt(test?.fixed_price).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : parseInt(test?.fixed_price).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_type_1_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row
                              className='mb-4'
                              hidden={roleUser == 'null' || roleUser == null ? true : false}
                            >
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('End Customer')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    test.end_user_multiple
                                      ? handleShowValue(test.end_user)
                                      : test.end_user
                                  }
                                  as='textarea'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='fs-6'>{t('keterangan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_note}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.notes}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      )}

                      {test?.sector_id == 3 && (
                        <Row>
                          <Col md='6'>
                            <h5 className='mb-3'>Before</h5>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>Sales Org</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.produsen?.name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={t(test.sector?.name)}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.incoterm1?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                              </Col>
                              <Col md={8}>
                                {test?.incoterm2 == null ? (
                                  <Form.Control
                                    value={
                                      test?.incoterm2_id == null || test?.incoterm2_id == '0'
                                        ? ''
                                        : test?.incoterm2_id
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                ) : (
                                  <Form.Control
                                    value={test?.incoterm2?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                )}
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.province?.region_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.city?.city_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_type_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    i18next.language === 'en'
                                      ? parseFloat(test?.fixed_quantum).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) + ' MT'
                                      : parseFloat(test?.fixed_quantum).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) + ' MT'
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-2'>
                              <Col md={4}>
                                <p className='fs-6 mt-3'>{t('Harga Pengajuan')}/MT</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    'USD' + i18next.language === 'en'
                                      ? parseFloat(test?.fixed_price).toLocaleString('en', {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 2,
                                        })
                                      : parseFloat(test?.fixed_price).toLocaleString('id', {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 2,
                                        })
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            {/* <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                              </Col>
                              <Col sm={8} className='d-flex justify-content-start'>
                                <Form.Check
                                  reverse
                                  name='ppn'
                                  className='mt-5 mb-2'
                                  type='checkbox'
                                  id='ckbox-ppn'
                                  checked={test?.include_ppn}
                                />
                              </Col>
                            </Row> */}
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_type_1_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_type_2_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='fs-6'>{t('keterangan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_note}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_spec}
                                  as='textarea'
                                  style={{height: '40px'}}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('End Customer')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    test.end_user_multiple
                                      ? handleShowValue(test.end_user)
                                      : test.end_user
                                  }
                                  as='textarea'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.notes}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            { !isRetail(test?.sector_id) && <>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    as='textarea'
                                    defaultValue={test?.amandement_notes}
                                    disabled
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                  />
                                </Col>
                              </Row>
                              <Row
                                className='mb-4'
                              >
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    as='textarea'
                                    defaultValue={test?.extension_date ? moment(test?.extension_date).format('DD/MM/YYYY') : ''}
                                    disabled
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                  />
                                </Col>
                              </Row>
                            </> }
                          </Col>
                          <Col md='6'>
                            <h5 className='mb-3'>After</h5>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>Sales Org</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.produsen?.name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={t(test.sector?.name)}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.incoterm1?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                              </Col>
                              <Col md={8}>
                                {test?.incoterm2 == null ? (
                                  <Form.Control
                                    value={
                                      test?.incoterm2_id == null || test?.incoterm2_id == '0'
                                        ? ''
                                        : test?.incoterm2_id
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                ) : (
                                  <Form.Control
                                    value={test?.incoterm2?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                )}
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.province?.region_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.city?.city_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_type_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    i18next.language === 'en'
                                      ? parseFloat(test?.fixed_quantum).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) + ' MT'
                                      : parseFloat(test?.fixed_quantum).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) + ' MT'
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-2'>
                              <Col md={4}>
                                <p className='fs-6 mt-3'>{t('Harga Pengajuan')}/MT</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    'USD' + i18next.language === 'en'
                                      ? parseFloat(test?.fixed_price).toLocaleString('en', {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 2,
                                        })
                                      : parseFloat(test?.fixed_price).toLocaleString('id', {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 2,
                                        })
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            {/* <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                              </Col>
                              <Col sm={8} className='d-flex justify-content-start'>
                                <Form.Check
                                  reverse
                                  name='ppn'
                                  className='mt-5 mb-2'
                                  type='checkbox'
                                  id='ckbox-ppn'
                                  checked={test?.include_ppn}
                                />
                              </Col>
                            </Row> */}
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_type_1_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_type_2_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='fs-6'>{t('keterangan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_note}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_spec}
                                  as='textarea'
                                  style={{height: '40px'}}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('End Customer')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    test.end_user_multiple
                                      ? handleShowValue(test.end_user)
                                      : test.end_user
                                  }
                                  as='textarea'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.notes}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            { !isRetail(test?.sector_id) && <>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    as='textarea'
                                    defaultValue={test?.amandement_notes}
                                    disabled
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                  />
                                </Col>
                              </Row>
                              <Row
                                className='mb-4'
                              >
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    as='textarea'
                                    defaultValue={test?.extension_date ? moment(test?.extension_date).format('DD/MM/YYYY') : ''}
                                    disabled
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                  />
                                </Col>
                              </Row>
                            </> }
                          </Col>
                        </Row>
                      )}
                    </>
                  ) : (
                    <>
                      {test?.sector_id == 1 && (
                        <Row>
                          <Col md='6'>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>Sales Org</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.produsen?.name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.incoterm1?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.province?.region_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_type_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    i18next.language === 'en'
                                      ? parseFloat(test?.request_quantum).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                      : parseFloat(test?.request_quantum).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('Kuantum Disetujui')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    i18next.language === 'en'
                                      ? parseFloat(![0,1,2,5,90].includes(test?.status) ? test?.fixed_quantum : 0).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                      : parseFloat(![0,1,2,5,90].includes(test?.status) ? test?.fixed_quantum : 0).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('Shipping Tolerance')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  // placeholder={t('Shipping Tolerance')}
                                  size='sm'
                                  type='text'
                                  id='shipping'
                                  value={
                                    test?.shipping_tolerance == 0
                                      ? ''
                                      : test?.shipping_tolerance + '%'
                                  }
                                  disabled
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_type_1_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('keterangan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_note}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='fs-6 mt-3'>{t('segment')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={t(test?.segment_name)}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('End Customer')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    test.end_user_multiple
                                      ? handleShowValue(test.end_user)
                                      : test.end_user
                                  }
                                  as='textarea'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col md='6'>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={t(test.sector?.name)}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                              </Col>
                              <Col md={8}>
                                {test?.incoterm2 == null ? (
                                  <Form.Control
                                    value={
                                      test?.incoterm2_id == null || test?.incoterm2_id == '0'
                                        ? ''
                                        : test?.incoterm2_id
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                ) : (
                                  <Form.Control
                                    value={test?.incoterm2?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                )}
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.city?.city_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-2'>
                              <Col md={4}>
                                <p className='fs-6 mt-3'>{t('Harga Pengajuan')}/Ton</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    'Rp' + i18next.language === 'en'
                                      ? parseFloat(test?.request_price).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : parseFloat(test?.request_price).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-2'>
                              <Col md={4}>
                                <p className='fs-6 mt-3'>{t('Harga Disetujui')}/Ton</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    'Rp' + i18next.language === 'en'
                                      ? parseFloat(![0,1,2,5,90].includes(test?.status) ? test?.fixed_price : 0).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : parseFloat(![0,1,2,5,90].includes(test?.status) ? test?.fixed_price : 0).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='my-7'>
                              <Col sm={6} className='d-flex '>
                                <Row sm={8} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('termasuk-ppn')}</p>
                                </Row>
                                <Row
                                  sm={4}
                                  className='d-flex justify-content-start align-items-center ms-4'
                                >
                                  <Form.Check
                                    reverse
                                    name='ppn'
                                    type='checkbox'
                                    id='ckbox-ppn'
                                    checked={test?.include_ppn}
                                  />
                                </Row>
                              </Col>
                              <Col sm={6} className='d-flex'>
                                <Row sm={8} className='d-flex align-items-center'>
                                  <p className=' fs-6'>{t('Formulated Price')}</p>
                                </Row>
                                <Row
                                  sm={4}
                                  className='d-flex justify-content-start align-items-center ms-4'
                                >
                                  <Form.Check
                                    reverse
                                    name='ppn'
                                    type='checkbox'
                                    id='ckbox-ppn'
                                    checked={test?.is_formulated_price}
                                  />
                                </Row>
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_type_2_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_spec}
                                  as='textarea'
                                  style={{height: '40px'}}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.notes}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            { !isRetail(test?.sector_id) && <>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    as='textarea'
                                    defaultValue={test?.amandement_notes}
                                    disabled
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                  />
                                </Col>
                              </Row>
                              <Row
                                className='mb-4'
                              >
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    as='textarea'
                                    defaultValue={test?.extension_date ? moment(test?.extension_date).format('DD/MM/YYYY') : ''}
                                    disabled
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                  />
                                </Col>
                              </Row>
                            </> }
                          </Col>
                        </Row>
                      )}

                      {isRetail(test?.sector_id) && (
                        <Row>
                          <Col md='6'>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>Sales Org</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.produsen?.name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.incoterm1?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('pickup-province')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.province?.region_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.plant_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('destination-province')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.province_dest?.region_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    i18next.language === 'en'
                                      ? parseFloat(test?.fixed_quantum).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                      : parseFloat(test?.fixed_quantum).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_type_1_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('commodity')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  placeholder={t('commodity')}
                                  id='note'
                                  size='sm'
                                  style={{height: '40px'}}
                                  value={test?.commodity}
                                  disabled
                                />
                              </Col>
                          </Row>
                          </Col>
                          <Col md='6'>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={t(test.sector?.name)}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                              </Col>
                              <Col md={8}>
                                {test?.incoterm2 == null ? (
                                  <Form.Control
                                    value={
                                      test?.incoterm2_id == null || test?.incoterm2_id == '0'
                                        ? ''
                                        : test?.incoterm2_id
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                ) : (
                                  <Form.Control
                                    value={test?.incoterm2?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                )}
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('pickup-city')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.city?.city_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_type_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_spec}
                                  as='textarea'
                                  style={{height: '40px'}}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('destination-city')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.city_dest?.city_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='fs-6 mt-3'>{t('Price')}/Ton</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    'Rp' + i18next.language === 'en'
                                      ? parseInt(test?.fixed_price).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : parseInt(test?.fixed_price).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('keterangan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_note}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.notes}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      )}

                      {test?.sector_id == 3 && (
                        <Row>
                          <Col md='6'>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>Sales Org</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.produsen?.name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.incoterm1?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.province?.region_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_type_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    i18next.language === 'en'
                                      ? parseFloat(test?.request_quantum).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) + ' MT'
                                      : parseFloat(test?.request_quantum).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) + ' MT'
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('Kuantum Disetujui')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    i18next.language === 'en'
                                      ? parseFloat(![0,1,2,5,90].includes(test?.status) ? test?.fixed_quantum : 0).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) + ' MT'
                                      : parseFloat(![0,1,2,5,90].includes(test?.status) ? test?.fixed_quantum : 0).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) + ' MT'
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('Shipping Tolerance')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  // placeholder={t('Shipping Tolerance')}
                                  size='sm'
                                  type='text'
                                  id='shipping'
                                  value={
                                    test?.shipping_tolerance == 0
                                      ? ''
                                      : test?.shipping_tolerance + '%'
                                  }
                                  disabled
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_type_1_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('keterangan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_note}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('End Customer')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    test.end_user_multiple
                                      ? handleShowValue(test.end_user)
                                      : test.end_user
                                  }
                                  as='textarea'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col md='6'>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={t(test.sector?.name)}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                              </Col>
                              <Col md={8}>
                                {test?.incoterm2 == null ? (
                                  <Form.Control
                                    value={
                                      test?.incoterm2_id == null || test?.incoterm2_id == '0'
                                        ? ''
                                        : test?.incoterm2_id
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                ) : (
                                  <Form.Control
                                    value={test?.incoterm2?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                )}
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  type='text'
                                  value={test.city?.city_name}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-2'>
                              <Col md={4}>
                                <p className='fs-6 mt-3'>{t('Harga Pengajuan')}/MT</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    'USD' + i18next.language === 'en'
                                      ? parseFloat(test?.request_price).toLocaleString('en', {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 2,
                                        })
                                      : parseFloat(test?.request_price).toLocaleString('id', {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 2,
                                        })
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-2'>
                              <Col md={4}>
                                <p className='fs-6 mt-3'>{t('Harga Disetujui')}/MT</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={
                                    'USD' + i18next.language === 'en'
                                      ? parseFloat(![0,1,2,5,90].includes(test?.status) ? test?.fixed_price : 0).toLocaleString('en', {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 2,
                                        })
                                      : parseFloat(![0,1,2,5,90].includes(test?.status) ? test?.fixed_price : 0).toLocaleString('id', {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 2,
                                        })
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>{t('Formulated Price')}</p>
                              </Col>
                              <Col sm={8} className='d-flex justify-content-start'>
                                <Form.Check
                                  reverse
                                  name='formula_Price'
                                  className='mt-5 mb-2'
                                  type='checkbox'
                                  id='formula_Price'
                                  checked={test?.is_formulated_price}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.payment_type_2_desc}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test.product_spec}
                                  as='textarea'
                                  style={{height: '40px'}}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col md={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col md={8}>
                                <Form.Control
                                  value={test?.notes}
                                  type='text'
                                  as='textarea'
                                  style={{height: '40px'}}
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            { !isRetail(test?.sector_id) && <>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    as='textarea'
                                    defaultValue={test?.amandement_notes}
                                    disabled
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                  />
                                </Col>
                              </Row>
                              <Row
                                className='mb-4'
                              >
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    as='textarea'
                                    defaultValue={test?.extension_date ? moment(test?.extension_date).format('DD/MM/YYYY') : ''}
                                    disabled
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                  />
                                </Col>
                              </Row>
                            </> }
                          </Col>
                        </Row>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              {nonpenjualan == 'INF-201' || nonpenjualan == 'INF-202' ? (
                <>
                  <Row>
                    <Col md={6}>
                      <Row className='mb-3'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('kontrak-produsen')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={test.produsen?.name}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>Incoterm</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={test?.incoterm1?.code}
                            type='text'
                            size='sm'
                            disabled
                          />
                        </Col>
                      </Row>

                      {test?.sector_id != 3 ? (
                        <>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                type='text'
                                size='sm'
                                value={test?.province?.region_name}
                                disabled
                              />
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ''
                      )}

                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-jenis')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={test.product_type_desc}
                            type='text'
                            size='sm'
                            disabled
                          />
                        </Col>
                      </Row>

                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('Kuantum Pengajuan')}</p>
                        </Col>
                        <Col sm={8}>
                          <InputGroup size='sm'>
                            <Form.Control
                              value={
                                (i18next.language === 'en'
                                  ? parseFloat(test?.fixed_quantum).toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : parseFloat(test?.fixed_quantum).toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })) + (test?.sector_id === 3 ? ' MT' : ' Ton')
                              }
                              type='text'
                              size='sm'
                              disabled
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('End Customer')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={
                              test.end_user_multiple
                                ? handleShowValue(test.end_user)
                                : test.end_user
                            }
                            as='textarea'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={t(test.sector?.name)}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>

                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={test?.notes}
                            as='textarea'
                            size='sm'
                            style={{height: '40px'}}
                            disabled
                          />
                        </Col>
                      </Row>

                      {test?.sector_id != 3 ? (
                        <>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                type='text'
                                size='sm'
                                value={test?.city?.city_name}
                                disabled
                              />
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ''
                      )}
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control value={test.product_name} type='text' size='sm' disabled />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>
                            {t('Harga Pengajuan')}/{test?.sector_id === 3 ? 'MT' : 'Ton'}
                          </p>
                        </Col>
                        <Col sm={8}>
                          {test?.sector_id != 3 ? (
                            <Form.Control
                              value={
                                'Rp' + i18next.language === 'en'
                                  ? parseFloat(test?.fixed_price).toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : parseFloat(test?.fixed_price).toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })
                              }
                              type='text'
                              size='sm'
                              disabled
                            />
                          ) : (
                            <Form.Control
                              value={
                                'USD' + i18next.language === 'en'
                                  ? parseFloat(test?.fixed_price).toLocaleString('en', {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 2,
                                    })
                                  : parseFloat(test?.fixed_price).toLocaleString('id', {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 2,
                                    })
                              }
                              type='text'
                              size='sm'
                              disabled
                            />
                          )}
                        </Col>
                      </Row>
                      <Row className='mb-4' hidden={test.sector_id != 3 ? false : true}>
                        <Col sm={4}>
                          <p className='mt-3 fs-6'>{t('termasuk-ppn')}</p>
                        </Col>
                        <Col sm={8} className='d-flex justify-content-start'>
                          <Form.Check
                            reverse
                            name='ppn'
                            className='mt-3 mb-2'
                            type='checkbox'
                            id='ckbox-ppn'
                            checked={test.include_ppn}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row className='mb-3'>
                    <Col sm={4}>
                      <p className='fs-6 mt-3'>{t('kontrak-produsen')}</p>
                    </Col>
                    <Col sm={8}>
                      <Form.Control value={test.produsen?.name} type='text' disabled size='sm' />
                    </Col>
                  </Row>
                  <Row className='mb-3'>
                    <Col sm={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                    </Col>
                    <Col sm={8}>
                      <Form.Control value={test.sector?.name} type='text' disabled size='sm' />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='fs-6 mt-3'>{t('sub-order-jenis')}</p>
                    </Col>
                    <Col sm={8}>
                      <Form.Control value={test.product_type_desc} type='text' size='sm' disabled />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='mt-4 fs-6'>{t('sub-order-produk')}</p>
                    </Col>
                    <Col sm={8}>
                      <Form.Control value={test.product_name} type='text' size='sm' disabled />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                    </Col>
                    <Col sm={8}>
                      <Form.Control
                        value={test?.notes}
                        as='textarea'
                        size='sm'
                        style={{height: '40px'}}
                        disabled
                      />
                    </Col>
                  </Row>
                </>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        size='lg'
        show={showUpload}
        onHide={() => {
          setShowUpload(false)
          setParam('')
          setIsPrivate(false)
          setRegarding('')
          setFileBox({})
        }}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {fileBox?.product_name
              ? (fileBox.province ? fileBox.province?.region_name : '') +
                (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                (fileBox.province ? ' | ' : '') +
                fileBox.product_name +
                (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
              : t('File Box')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {is_amandemen == 'false' ? (
            <>
              {!downloadOnly && (
                <Row>
                  <Col sm={6}>
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('order-fileUnggah')}</h6>
                        </td>
                        <td className='w-75'>
                          <InputFile
                            setFileName={setNamaFile}
                            setFiles={setFiles}
                            isBase64={false}
                          />
                        </td>
                      </tr>
                    </table>
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('order-keterangan')}</h6>
                        </td>
                        <td className='w-75'>
                          <Form.Control
                            type='text'
                            id='uploadketerangan'
                            placeholder={t('order-keterangan')}
                            onChange={(e: any) => setDescription(e.target.value)}
                          />
                        </td>
                      </tr>
                    </table>
                    <table
                      className='mb-3'
                      hidden={roleUser != null && roleUser != 'null' ? false : true}
                    >
                      <tr>
                        <td>
                          <h6 className='me-11'>{t('Private')}</h6>
                        </td>
                        <td className='w-75 d-flex justify-content-start'>
                          <Form.Check
                            reverse
                            name='isPrivate'
                            type='checkbox'
                            className='mt-5 mb-2'
                            onClick={() => {
                              setIsPrivate(!isPrivate)
                              setTempRole([])
                            }}
                            id='isPrivate'
                          />
                        </td>
                      </tr>
                    </table>
                    <table className='mb-3' hidden={isPrivate ? false : true}>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('Akses Role')}</h6>
                        </td>
                        <td className='w-75' style={{maxWidth: '274px'}}>
                          <MultiSelect
                            key={isPrivate.toString()}
                            options={fullRole?.map((item: any) => {
                              return {label: item.label, value: item.value}
                            })}
                            value={tempRole}
                            onChange={(e: any) => setTempRole(e)}
                            labelledBy='Select'
                          />
                        </td>
                      </tr>
                    </table>
                    <div className='d-flex justify-content-end'>
                      <Button
                        variant='primary'
                        className='w-100'
                        onClick={() => handleUpload()}
                        disabled={btnLoading}
                      >
                        {btnLoading ? (
                          <Spinner animation='border' variant='light' size='sm' />
                        ) : (
                          t('order-kirim')
                        )}
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}

              {allFile.length < 1 || allFile.length == undefined ? (
                <></>
              ) : (
                <div className='table-responsive mt-4 bdr'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='fw-bold border-bottom'>
                      <tr className=''>
                        <th className='text-center px-2'>{t('order-noo')}</th>
                        <th className='text-center'>{t('order-keterangan')}</th>
                        <th className='text-center'>{t('order-tglUpload')}</th>
                        {/* <th className='text-center'>{t('User Code')}</th> */}
                        <th className='text-center'>{t('order-user')}</th>
                        <th className='text-center'>{t('Akses Role')}</th>
                        <th className='text-center'>{t('order-aksi')}</th>
                      </tr>
                    </thead>
                    {allFile.map((data: any, _index: any) => (
                      <tbody key={data?.id ?? _index}>
                        <tr className=''>
                          <td className='text-center'>
                            <label>{_index + 1}</label>
                          </td>
                          <td className='text-center'>
                            <label>{data.description}</label>
                          </td>
                          <td className='text-center'>
                            <label>{dateformat(data.updated_at)}</label>
                          </td>
                          {/* <td className='text-center'>
                            <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                          </td> */}
                          <td className='text-center'>
                            {data.user?.customer_code == null ? (
                              <label>{data.user?.name}</label>
                            ) : (
                              <label>{data.user?.customer?.name}</label>
                            )}
                          </td>
                          <td className='text-center'>
                            {data.private ? (
                              data.roles.length > 0 ? (
                                <PopoverText
                                  content={handleShowRoleName(data.roles)}
                                  index={_index}
                                  className='desc-slice'
                                />
                              ) : (
                                'Private'
                              )
                            ) : (
                              'Public'
                            )}
                          </td>
                          <td className='text-center'>
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('unduh')}
                              onClick={() =>
                                window.open(
                                  data.file_path + `&token=${localStorage.getItem('token')}`
                                )
                              }
                            >
                              <KTSVG
                                path='/media/icons/duotune/arrow-down-square-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            {(accsessDelete || CheckSameIDAttachment(data.user_role_flag)) && (
                              <button
                                onClick={() => deleteAttachment(data.id)}
                                className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Hapus')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/trash-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              )}
            </>
          ) : (
            <>
              {allFile.length < 1 || allFile.length == undefined ? (
                <></>
              ) : (
                <div className='table-responsive mt-4 bdr'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='fw-bold border-bottom'>
                      <tr className=''>
                        <th className='text-center px-2'>{t('order-noo')}</th>
                        <th className='text-center'>{t('order-keterangan')}</th>
                        <th className='text-center'>{t('order-tglUpload')}</th>
                        {/* <th className='text-center'>{t('User Code')}</th> */}
                        <th className='text-center'>{t('order-user')}</th>
                        <th className='text-center'>{t('Akses Role')}</th>
                        <th className='text-center'>{t('order-aksi')}</th>
                      </tr>
                    </thead>
                    {allFile.map((data: any, _index: any) => (
                      <tbody key={data?.id ?? _index}>
                        <tr className=''>
                          <td className='text-center'>
                            <label>{_index + 1}</label>
                          </td>
                          <td className='text-center'>
                            <label>{data.description}</label>
                          </td>
                          <td className='text-center'>
                            <label>{dateformat(data.updated_at)}</label>
                          </td>
                          {/* <td className='text-center'>
                            <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                          </td> */}
                          <td className='text-center'>
                            {data.user?.customer_code == null ? (
                              <label>{data.user?.name}</label>
                            ) : (
                              <label>{data.user?.customer?.name}</label>
                            )}
                          </td>
                          <td className='text-center'>
                            {data.private ? (
                              data.roles.length > 0 ? (
                                <PopoverText
                                  content={handleShowRoleName(data.roles)}
                                  index={_index}
                                  className='desc-slice'
                                />
                              ) : (
                                'Private'
                              )
                            ) : (
                              'Public'
                            )}
                          </td>
                          <td className='text-center'>
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('unduh')}
                              onClick={() =>
                                window.open(
                                  data.file_path + `&token=${localStorage.getItem('token')}`
                                )
                              }
                            >
                              <KTSVG
                                path='/media/icons/duotune/arrow-down-square-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            {(accsessDelete || CheckSameIDAttachment(data.user_role_flag)) && (
                              <button
                                onClick={() => deleteAttachment(data.id)}
                                className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm ${
                                  roleUser == 'admin' ? 'd-none' : ''
                                }`}
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Hapus')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/trash-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        size='xl'
        show={show4}
        onHide={handleClose4}
        backdrop='static'
        keyboard={false}
        centered
        className='modal-tracking'
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Tracking')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-12 col-md-6 mb-3 mb-md-0'>
              <div className='detail-tracking'>
                <div className='line-tracking number-tracking'>
                  <p className='title-detail'>PO = {t('Order submission')}</p>
                </div>
                <div className='line-tracking number-tracking'>
                  <p className='title-detail'>PN = {t('Proses Negosiasi')}</p>
                </div>
                <div className='line-tracking number-tracking'>
                  <p className='title-detail'>SIP = {t('Surat Instruksi Penjualan')}</p>
                </div>
                <div className='line-tracking number-tracking'>
                  <p className='title-detail'>SO = Sales Order</p>
                </div>
                <div className='line-tracking number-tracking'>
                  <p className='title-detail'>DO = Delivery Order</p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6'>
              <div className='process-tracking'>
                <div className='tracking-images'>
                  <img src={toAbsoluteUrl(`/media/tracking-vector.svg`)} />
                </div>
                <div className='card py-5'>
                  {isLoadingTracking ? (
                    <SkeletonTracking />
                  ) : (
                    track?.map((item: any, index: number) => (
                      <div key={item?.name ?? index} className='tracking'>
                        <div className='process-track'>
                          <div className='bullets-track now-proccess'></div>
                          <div className='line-track'></div>
                        </div>
                        <p className='name-process mb-5 w-100'>
                          {handleTrack(item?.name)} - {item?.user}
                          <br />
                          {item?.date ? formatDate(item?.date) : <></>}
                        </p>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <AttachmentModal />
      {/* <ChatOrderModal /> */}

      {roleUser == null || roleUser == 'null' ? (
        <Pagination paginate={paginateNumber} test={numberURL} />
      ) : (
        hakAkses?.read && <Pagination paginate={paginateNumber} test={numberURL} />
      )}
    </StyledCard>
  )
}

export {TableOrder}
